<template>
  <div
    ref="modal"
    class="modal fade"
    :class="{ show: showModal, 'd-block': showModal }"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-xxl modal-fullscreen-md-down"
      role="document"
    >
      <div class="modal-content">
        <!-- Header -->
        <div
          class="modal-header bg-primary text-white d-flex align-items-center"
        >
          <h5 class="modal-title fw-semibold m-0 flex-grow-1 text-center">
            Freight Builder
          </h5>

          <button
            type="button"
            class="btn p-0 refresh-btn"
            @click="closeModal"
            title="Close"
            style="filter: invert(1)"
          >
            <span class="mdi mdi-close-box-multiple fs-3"></span>
          </button>
        </div>
        <div class="card-header">
          <!-- ================== SECTION 1: LOAD ID & SLIDE PANEL ================== -->
          <div class="section-block">
            <div class="row align-items-center mb-0">
              <div
                v-if="selectedUnit != 'Shipment to Existing Load'"
                class="col-md-1"
              >
                <label class="fw-semibold mb-0" style="min-width: 100px"
                  >New Load ID</label
                >
              </div>
              <div
                v-if="selectedUnit != 'Shipment to Existing Load'"
                class="col-auto"
                style="position: relative; max-width: 250px"
              >
                <input
                  type="text"
                  class="form-control form-control-sm readonly-input text-center"
                  readonly
                  style="padding-right: 2rem"
                  :value="!isLoadingLoadId ? loadId : ''"
                />

                <!-- 🔹 Spinner tampil di tengah input saat loading -->
                <div
                  v-if="isLoadingLoadId"
                  class="position-absolute top-50 start-50 translate-middle"
                >
                  <div
                    class="spinner-border spinner-border-sm text-primary"
                    role="status"
                    style="width: 1rem; height: 1rem"
                  ></div>
                </div>
              </div>

              <div
                class="col d-flex justify-content-end align-items-center gap-3"
                v-if="!isBlujaySent"
              >
                <button
                  v-if="selectedIndexes.length > 0"
                  class="btn btn-danger btn-sm"
                  @click="deleteSelectedRows"
                >
                  <span
                    v-if="isLoadingDeleteShipment"
                    class="spinner-border spinner-border-sm ms-auto me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="mdi mdi-delete"></i> Delete
                </button>

                <div class="text-muted small">
                  Total selected : <strong>{{ selectedIndexes.length }}</strong>
                </div>
                <div class="text-muted small">
                  Total shipment : <strong>{{ totalShipment }}</strong>
                </div>

                <button class="btn btn-danger btn-sm" @click="openSlidePanel">
                  <i class="mdi mdi-plus me-1"></i> Tambahkan Shipment Ke Load
                </button>
              </div>
            </div>

            <!-- Slide Panel -->
            <div class="slide-panel" :class="{ open: showSlidePanel }">
              <div
                class="slide-header d-flex align-items-center p-2 border-bottom bg-white"
              >
                <h5 class="m-0 flex-grow-1" v-html="slideHeaderText"></h5>

                <div class="d-flex align-items-center gap-3 ms-auto">
                  <div class="text-muted small">
                    Total selected:
                    <strong>{{ selectedSlideIndexes.length }}</strong>
                  </div>
                  <button
                    class="btn btn-sm btn-secondary"
                    @click="closeSlidePanel"
                  >
                    Close
                  </button>
                </div>
              </div>

              <!-- ❗ Bagian bawah (body + tabel) tetap sama, tidak berubah -->
              <div class="slide-body p-2">
                <div class="row mb-2">
                  <div class="col-12">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="globalFilter"
                      placeholder="Cari shipment..."
                    />
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between align-items-center mb-2 flex-wrap"
                >
                  <!-- Show Per Page -->
                  <div class="d-flex align-items-center gap-2 mb-2 mb-md-0">
                    <label class="mb-0 small">Show</label>
                    <select
                      v-model="perPageSlide"
                      class="form-select form-select-sm w-auto"
                    >
                      <option
                        v-for="n in [5, 10, 25, 50, 100]"
                        :key="n"
                        :value="n"
                      >
                        {{ n }}
                      </option>
                    </select>
                    <label class="mb-0 small">entries</label>
                  </div>

                  <!-- Info -->
                  <small class="pagination-info">
                    Showing {{ startRecordSlide }} to {{ endRecordSlide }} of
                    {{ filteredRows.length }} entries
                  </small>

                  <!-- Pagination -->
                  <ul class="pagination pagination-sm mb-0">
                    <li
                      class="page-item"
                      :class="{ disabled: currentPageSlide === 1 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="prevPageSlide"
                        >Previous</a
                      >
                    </li>

                    <li v-if="pageNumbersSlide[0] > 1" class="page-item">
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPageSlide(1)"
                        >1</a
                      >
                    </li>
                    <li
                      v-if="pageNumbersSlide[0] > 2"
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-for="page in pageNumbersSlide"
                      :key="page"
                      class="page-item"
                      :class="{ active: page === currentPageSlide }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPageSlide(page)"
                        >{{ page }}</a
                      >
                    </li>

                    <li
                      v-if="
                        pageNumbersSlide[pageNumbersSlide.length - 1] <
                        totalPagesSlide - 1
                      "
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-if="
                        pageNumbersSlide[pageNumbersSlide.length - 1] <
                        totalPagesSlide
                      "
                      class="page-item"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPageSlide(totalPagesSlide)"
                      >
                        {{ totalPagesSlide }}
                      </a>
                    </li>

                    <li
                      class="page-item"
                      :class="{
                        disabled: currentPageSlide === totalPagesSlide,
                      }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="nextPageSlide"
                        >Next</a
                      >
                    </li>
                  </ul>
                </div>

                <div class="table-scroll-wrapper border rounded bg-white">
                  <div
                    ref="topScrollSlide"
                    class="top-scrollbar"
                    @scroll="syncScrollSlide"
                  >
                    <div class="scroll-content"></div>
                  </div>
                  <div
                    ref="bottomScrollSlide"
                    class="bottom-scrollbar"
                    @scroll="syncScrollSlide"
                  >
                    <table
                      class="table table-bordered table-hover table-sm mb-0"
                    >
                      <thead>
                        <tr>
                          <th style="width: 40px; text-align: center">
                            <input
                              type="checkbox"
                              v-model="selectAllSlide"
                              @change="toggleSelectAllSlide"
                            />
                          </th>
                          <th
                            v-for="col in columnListShipments"
                            :key="col.field"
                            :style="{ width: col.width }"
                          >
                            {{ col.label }}
                          </th>
                        </tr>
                        <!-- 🔥 FILTER PER COLUMN -->
                        <tr>
                          <th></th>
                          <th
                            v-for="col in columnListShipments"
                            :key="col.field"
                          >
                            <input
                              v-if="isFilterableColumn(col.field)"
                              type="text"
                              class="form-control form-control-sm"
                              v-model="columnFilters[col.field]"
                              @keyup.enter="applyColumnFilter"
                              placeholder="Search..."
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="isLoadingShipmentListAvailable">
                          <td
                            :colspan="columnListShipments.length + 1"
                            class="text-center py-4"
                          >
                            <div
                              class="d-flex justify-content-center align-items-center gap-2"
                            >
                              <div
                                class="spinner-border text-primary"
                                role="status"
                              ></div>
                              <span class="text-muted">Loading Data...</span>
                            </div>
                          </td>
                        </tr>

                        <tr
                          v-else-if="
                            !isLoadingShipmentListAvailable &&
                            filteredRows.length === 0
                          "
                        >
                          <td
                            :colspan="columnListShipments.length + 1"
                            class="text-center text-muted py-4"
                          >
                            Tidak ditemukan data yang cocok
                          </td>
                        </tr>

                        <tr
                          v-else
                          v-for="row in paginatedRowsSlide"
                          :key="row.transport_order_header_id"
                          :class="{ 'selected-row': isSelectedSlide(row) }"
                          @click="toggleRowSelectionSlide(row)"
                          style="cursor: pointer"
                        >
                          <td style="text-align: center">
                            <input
                              type="checkbox"
                              :value="row.transport_order_header_id"
                              v-model="selectedSlideIndexes"
                              @click.stop
                            />
                          </td>

                          <td
                            v-for="col in columnListShipments"
                            :key="col.field"
                            v-html="row[col.field]"
                          ></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="mt-2 text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="addSelectedShipments"
                    :disabled="selectedSlideIndexes.length === 0"
                  >
                    <span
                      v-if="isLoadingAddShipment"
                      class="spinner-border spinner-border-sm ms-auto me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Tambahkan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Body -->
        <div
          class="modal-body px-4 py-3"
          style="max-height: 88vh; overflow-y: auto"
        >
          <!-- ================== SECTION 2: SHIPMENT LOAD TABLE ================== -->
          <div class="section-block mb-4">
            <div class="border rounded bg-white">
              <!-- ✅ Jika showTable true → tampilkan tabel -->
              <div v-if="showTable">
                <div ref="topScroll" class="top-scrollbar" @scroll="syncScroll">
                  <div class="scroll-content"></div>
                </div>

                <div class="table-scroll border-top">
                  <table class="table table-bordered table-hover table-sm mb-0">
                    <thead>
                      <tr>
                        <!-- checkbox select all -->
                        <th
                          v-if="!isAfterSubmitSuccess"
                          style="width: 40px; text-align: center"
                        >
                          <input
                            type="checkbox"
                            v-model="selectAll"
                            @change="toggleSelectAll"
                          />
                        </th>

                        <!-- kolom dinamis -->
                        <th
                          v-for="col in columns"
                          :key="col.field"
                          :style="{
                            width: col.width,
                            textAlign: col.field === '__main__' ? 'center' : '',
                          }"
                        >
                          {{ col.label }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <!-- 🔄 LOADING -->
                      <tr v-if="isLoadingShipmentFB">
                        <td
                          :colspan="columns.length + 1"
                          class="text-center py-4"
                        >
                          <div
                            class="d-flex justify-content-center align-items-center gap-2"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="text-muted">Loading Data...</span>
                          </div>
                        </td>
                      </tr>

                      <!-- ❌ EMPTY -->
                      <tr v-else-if="rows.length === 0">
                        <td
                          :colspan="columns.length + 1"
                          class="text-center text-muted py-4"
                        >
                          Tidak ada data yang tersedia
                        </td>
                      </tr>

                      <!-- ✅ DATA -->
                      <tr
                        v-else
                        v-for="(row, i) in rows"
                        :key="row.transport_order_header_id"
                        :class="{
                          'selected-row': isSelected(i),
                          'highlight-row':
                            row.transport_order_header_id ===
                            transport_order_header_id_max,
                        }"
                        @click="!isAfterSubmitSuccess && toggleRowSelection(i)"
                        style="cursor: pointer"
                      >
                        <!-- checkbox select row -->
                        <td
                          v-if="!isAfterSubmitSuccess"
                          style="text-align: center"
                        >
                          <input
                            type="checkbox"
                            v-model="selectedIndexes"
                            :value="i"
                            @click.stop
                          />
                        </td>

                        <!-- kolom dinamis -->
                        <td v-for="col in columns" :key="col.field">
                          <!-- 🔥 MAIN -->
                          <template v-if="col.field === '__main__'">
                            <div style="text-align: center">
                              <input
                                type="checkbox"
                                :checked="
                                  row.transport_order_header_id ===
                                  transport_order_header_id_max
                                "
                                :disabled="
                                  isAfterSubmitSuccess || isMainDisabled(row)
                                "
                                @change="onMainChange(row)"
                                @click.stop
                              />
                            </div>
                          </template>

                          <!-- jarak -->
                          <template v-else-if="col.field === 'jarak'">
                            <div v-if="row.jarak_loading" class="text-center">
                              <div
                                class="spinner-border spinner-border-sm text-primary"
                              ></div>
                            </div>
                            <span v-else v-html="row.jarak"></span>
                          </template>

                          <!-- kolom biasa -->
                          <template v-else>
                            <span v-html="row[col.field]"></span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- ✅ Jika showTable false → tampilkan 1 shipment dalam card -->
              <div v-else>
                <div v-if="rows.length > 0" class="p-3">
                  <div class="card border shadow-sm">
                    <div class="card-body">
                      <!-- Baris 1: Customer & Pickup -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Customer
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].customer || ''"
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-start mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Pickup
                          </div>
                          <div
                            class="form-control form-control-sm bg-light"
                            style="
                              height: auto;
                              min-height: 38px;
                              white-space: normal;
                              overflow: hidden;
                            "
                            v-html="rows[0].pickup"
                          ></div>
                        </div>
                      </div>

                      <!-- Baris 2: Order No & Drop -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Order No
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].order || ''"
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-start mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Drop
                          </div>
                          <div
                            class="form-control form-control-sm bg-light"
                            style="
                              height: auto;
                              min-height: 38px;
                              white-space: normal;
                              overflow: hidden;
                            "
                            v-html="rows[0].drop"
                          ></div>
                        </div>
                      </div>

                      <!-- Baris 3: Shipment Type & Tonase -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Shipment Type
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="
                              rows[0].shipment_type
                                ? rows[0].shipment_type.replace(/<[^>]+>/g, '')
                                : ''
                            "
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Tonase
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].tonase || ''"
                            readonly
                          />
                        </div>
                      </div>

                      <!-- Baris 4: ShipWithRef & Jarak -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            ShipWithRef
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].shipwithref || ''"
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Jarak
                          </div>

                          <div class="d-flex align-items-center w-100">
                            <!-- Spinner -->
                            <div
                              v-if="rows[0].jarak_loading"
                              class="spinner-border spinner-border-sm text-primary"
                            ></div>

                            <!-- Value -->
                            <input
                              v-else
                              type="text"
                              class="form-control form-control-sm"
                              :value="rows[0].jarak || ''"
                              readonly
                            />
                          </div>
                        </div>
                      </div>

                      <!-- Baris 5: Tambahkan field lain jika perlu -->
                    </div>
                  </div>
                </div>

                <div v-else-if="isLoadingShipmentFB" class="text-center py-4">
                  <div
                    class="spinner-border text-primary spinner-border-sm"
                  ></div>
                  <span class="ms-2 text-muted">Loading Data...</span>
                </div>

                <div v-else class="text-center text-muted py-4">
                  Tidak ada data yang tersedia
                </div>
              </div>
            </div>
          </div>

          <!-- response be -->
          <div class="section-block">
            <!-- 🔵 GLOBAL PROCESSING MESSAGE -->
            <div
              v-if="isProcessing"
              class="p-3 mb-3 alert alert-info"
              style="border-radius: 8px"
            >
              <div class="fw-bold" style="font-size: 15px">
                Sedang Proses...
              </div>
              <div style="font-size: 13px">
                Mohon tunggu, sistem sedang memproses permintaan Anda.
              </div>
            </div>

            <!-- 🔴 GLOBAL SUCCESS / ERROR MESSAGES -->
            <div v-if="globalMessages.length > 0">
              <div
                v-for="msg in globalMessages"
                :key="msg.id"
                class="p-3 mb-3"
                :class="
                  msg.type === 'success'
                    ? 'alert alert-success'
                    : 'alert alert-danger'
                "
                style="border-radius: 8px; position: relative"
              >
                <!-- Tombol close hanya untuk success -->
                <button
                  v-if="msg.type === 'success'"
                  type="button"
                  class="btn-close"
                  style="position: absolute; top: 8px; right: 10px"
                  @click="removeMessage(msg.id)"
                ></button>

                <div class="fw-bold" style="font-size: 15px">
                  {{ msg.title }}
                </div>

                <div style="font-size: 13px">
                  {{ msg.message }}
                </div>
              </div>
            </div>
          </div>

          <!-- ================== SECTION 3: UNIT & PAYABLE ================== -->
          <div class="section-block mb-2" v-if="!isBlujaySent">
            <div class="row">
              <div class="card col-md-5 border-end pe-4 p-3 me-3 ms-2">
                <div class="row align-items-center mb-2">
                  <div class="col-md-2">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Unit
                    </label>
                  </div>
                  <div class="col-md-10">
                    <div class="d-flex gap-3">
                      <div class="form-check" v-if="showUnitRadio">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="unitOwn"
                          value="Own"
                          v-model="selectedUnit"
                        />
                        <label class="form-check-label" for="unitOwn"
                          >Own</label
                        >
                      </div>
                      <div class="form-check" v-if="showUnitRadio">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="unitVendor"
                          value="Vendor"
                          v-model="selectedUnit"
                        />
                        <label class="form-check-label" for="unitVendor"
                          >Vendor</label
                        >
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="unitExisting"
                          value="Shipment to Existing Load"
                          v-model="selectedUnit"
                        />
                        <label class="form-check-label" for="unitExisting">
                          Shipment to Existing Load
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Load ID hanya tampil jika Shipment to Existing Load dipilih -->
                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit === 'Shipment to Existing Load'"
                >
                  <div class="col-md-2">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Load ID Exist
                    </label>
                  </div>
                  <div class="col-md-8">
                    <BaseSelect
                      v-model="loadIdExist"
                      :options="dropDownLoadIdExists"
                      label-key="label"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchLoadIdExist"
                      :loading="isSearchingLoadIdExist"
                      :invalid="!!errors.load_id"
                      @update:modelValue="handleLoadIdExistChange"
                      @clear="onClearLoadIdExist"
                    />

                    <div v-if="errors.load_id">
                      <div class="alert alert-primary" role="alert">
                        <i data-feather="alert-circle"></i>
                        {{ errors.load_id[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit !== 'Shipment to Existing Load'"
                >
                  <div class="col-md-2">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Payable</label
                    >
                  </div>
                  <div class="col-md-3 position-relative">
                    <input
                      type="text"
                      class="form-control form-control-sm readonly-input"
                      :value="!isLoadingPayable ? payableResult : ''"
                      readonly
                    />
                    <div
                      v-if="isLoadingPayable"
                      class="position-absolute top-50 start-50 translate-middle"
                    >
                      <div
                        class="spinner-border spinner-border-sm text-primary"
                        role="status"
                        style="width: 1rem; height: 1rem"
                      ></div>
                    </div>
                  </div>

                  <div class="col-md-4" v-if="payableStatus">
                    <strong>{{ payableStatus }}</strong>
                  </div>
                </div>

                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit !== 'Shipment to Existing Load'"
                >
                  <div class="col-md-2">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Margin</label
                    >
                  </div>
                  <div class="col-md-3 position-relative">
                    <input
                      type="text"
                      class="form-control form-control-sm readonly-input"
                      :value="!isLoadingMargin ? marginResult : ''"
                      readonly
                    />
                    <div
                      v-if="isLoadingMargin"
                      class="position-absolute top-50 start-50 translate-middle"
                    >
                      <div
                        class="spinner-border spinner-border-sm text-primary"
                        role="status"
                        style="width: 1rem; height: 1rem"
                      ></div>
                    </div>
                  </div>

                  <div class="col-md-4" v-if="marginStatus">
                    <strong>{{ marginStatus }}</strong>
                  </div>
                </div>

                <div class="row align-items-center mb-2">
                  <div class="col-md-2">
                    <label
                      class="fw-semibold mb-0"
                      style="min-width: 100px"
                    ></label>
                  </div>
                </div>
              </div>

              <div class="card col-md-6 border-end pe-4 p-3">
                <!-- 🔹 Transporter -->
                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit !== 'Own'"
                >
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Transporter</label
                    >
                  </div>

                  <div class="col-md-7">
                    <div v-if="isExistingLoadMode">
                      <input
                        type="text"
                        class="form-control form-control-sm readonly-input"
                        :value="carrier_name?.carrier_name || ''"
                        readonly
                        ondblclick="this.select()"
                      />
                    </div>
                    <div v-else>
                      <BaseSelect
                        v-model="carrier_name"
                        :options="dropDownTransporters"
                        label-key="carrier_name"
                        placeholder="-- Cari & Pilih --"
                        :search-fn="asyncSearchTransporter"
                        :disabled="isExistingLoadMode"
                        :invalid="!!errors.carrier_name"
                        @clear="onClearCarrierName"
                        @update:modelValue="onCarrierPicked"
                      />
                    </div>

                    <div v-if="errors.carrier_name" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.carrier_name[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Type Truck -->
                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit !== 'Own'"
                >
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Type Truck</label
                    >
                  </div>
                  <div class="col-md-7">
                    <div v-if="isExistingLoadMode">
                      <input
                        type="text"
                        class="form-control form-control-sm readonly-input"
                        :value="type_truck?.type_truck || ''"
                        readonly
                        ondblclick="this.select()"
                      />
                    </div>
                    <div v-else>
                      <BaseSelect
                        :key="typeTruckSelectKey"
                        v-model="type_truck"
                        :options="dropDownTypeTrucks"
                        label-key="type_truck"
                        value-key="master_type_truck_id"
                        placeholder="-- Cari & Pilih --"
                        :disabled="isExistingLoadMode"
                        :invalid="!!errors.type_truck"
                        :search-fn="asyncSearchTypeTruck"
                        @clear="onClearTypeTruck"
                        @update:modelValue="onTypeTruckPicked"
                      />
                    </div>

                    <div v-if="errors.type_truck" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.type_truck[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Vehicle No -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0">Vehicle No</label>
                  </div>

                  <div class="col-md-7">
                    <!-- EXISTING LOAD -->
                    <input
                      v-if="isExistingLoadMode"
                      type="text"
                      class="form-control form-control-sm readonly-input"
                      :value="vehicle_no?.vehicle_no || ''"
                      readonly
                    />

                    <!-- OWN -->
                    <BaseSelect
                      v-else-if="!isVendorUnit"
                      v-model="vehicle_no"
                      :options="dropDownVehicleNos"
                      label-key="vehicle_status"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchVehicleNo"
                      @update:modelValue="onVehiclePicked"
                    />

                    <!-- VENDOR -->
                    <template v-else>
                      <!-- LOADING -->
                      <BaseSelect
                        v-if="isLoadingVendorData"
                        disabled
                        placeholder="Loading vehicle..."
                        :options="[]"
                      />

                      <!-- BELUM SIAP -->
                      <BaseSelect
                        v-else-if="!canCheckVendorData"
                        disabled
                        placeholder="Pilih Transporter & Type Truck dulu"
                        :options="[]"
                      />

                      <!-- DATA ADA -->
                      <BaseSelect
                        v-else-if="hasVendorVehicleData"
                        :key="vehicleSelectKey"
                        v-model="vehicle_no"
                        :options="dropDownVehicleNos"
                        label-key="vehicle_status"
                        value-key="vehicle_no"
                        placeholder="-- Cari & Pilih --"
                        @update:modelValue="onVehiclePicked"
                      />

                      <!-- DATA KOSONG -->
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-sm"
                        v-model="vehicle_no_vendor_text"
                      />
                    </template>
                  </div>
                </div>

                <!-- 🔹 Driver -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0">Driver</label>
                  </div>

                  <div class="col-md-7">
                    <!-- EXISTING LOAD -->
                    <input
                      v-if="isExistingLoadMode"
                      type="text"
                      class="form-control form-control-sm readonly-input"
                      :value="driver_id ? customLabelDriver(driver_id) : ''"
                      readonly
                    />

                    <!-- OWN -->
                    <BaseSelect
                      v-else-if="!isVendorUnit"
                      v-model="driver_id"
                      :options="dropDownDrivers"
                      :label-fn="customLabelDriver"
                      value-key="driver_id"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchDriver"
                      @update:modelValue="onDriverPicked"
                    />

                    <!-- VENDOR -->
                    <template v-else>
                      <!-- LOADING -->
                      <BaseSelect
                        v-if="isLoadingVendorData"
                        disabled
                        placeholder="Loading driver..."
                        :options="[]"
                      />

                      <!-- BELUM SIAP -->
                      <BaseSelect
                        v-else-if="!canCheckVendorData"
                        disabled
                        placeholder="Pilih Transporter & Type Truck dulu"
                        :options="[]"
                      />

                      <!-- DATA ADA -->
                      <BaseSelect
                        v-else-if="hasVendorDriverData"
                        v-model="driver_id"
                        :options="dropDownDrivers"
                        :label-fn="customLabelDriver"
                        value-key="driver_id"
                        placeholder="-- Cari & Pilih --"
                        @update:modelValue="onDriverPicked"
                      />

                      <!-- DATA KOSONG -->
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-sm"
                        v-model="driver_vendor_text"
                      />
                    </template>
                  </div>
                </div>

                <!-- 🔹 Automatic Process -->
                <div v-if="false" class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Automatic Process</label
                    >
                  </div>
                  <div class="col-md-7">
                    <div v-if="isExistingLoadMode">
                      <input
                        type="text"
                        class="form-control form-control-sm readonly-input"
                        :value="autoProcess || ''"
                        readonly
                        ondblclick="this.select()"
                      />
                    </div>
                    <div v-else>
                      <!-- <v-select
                        :disabled="isExistingLoadMode"
                        :options="autoProcessOptions"
                        v-model="autoProcess"
                        label="label"
                        :reduce="(option) => option.value"
                        placeholder="-- Cari & Pilih --"
                        :class="{ 'is-invalid': errors.autoProcess }"
                      ></v-select> -->
                      <BaseSelect
                        :disabled="isExistingLoadMode"
                        :options="autoProcessOptions"
                        :value="selectedAutoProcess"
                        label-key="label"
                        placeholder="-- Cari & Pilih --"
                        :invalid="!!errors.autoProcess"
                        @input="onAutoProcessPicked"
                      />
                    </div>

                    <div v-if="errors.autoProcess" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.autoProcess[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2"></div>
                </div>

                <!-- 🔹 Customer Tujuan -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Customer Tujuan</label
                    >
                  </div>
                  <div class="col-md-7">
                    <div v-if="isExistingLoadMode">
                      <input
                        type="text"
                        class="form-control form-control-sm readonly-input"
                        :value="cust_tujuan || ''"
                        readonly
                        ondblclick="this.select()"
                      />
                    </div>
                    <div v-else>
                      <!-- <v-select
                        :disabled="isExistingLoadMode"
                        placeholder="-- Cari & Pilih --"
                        :options="dropDownCustTujuans"
                        v-model="cust_tujuan"
                        label="value"
                        :reduce="(item) => item.value"
                        @search="asyncSearchCustTujuan"
                        :loading="isSearchingCustTujuan"
                        :class="{ 'is-invalid': errors.cust_tujuan }"
                      ></v-select> -->
                      <BaseSelect
                        :disabled="isExistingLoadMode"
                        :options="dropDownCustTujuans"
                        :value="selectedCustTujuan"
                        label-key="value"
                        placeholder="-- Cari & Pilih --"
                        :search-fn="asyncSearchCustTujuan"
                        :invalid="!!errors.cust_tujuan"
                        @input="onCustTujuanPicked"
                      />
                    </div>

                    <div v-if="errors.cust_tujuan" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.cust_tujuan[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Trailer No -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Trailer No
                    </label>
                  </div>

                  <div class="col-md-7">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="trailer_no"
                      :readonly="isExistingLoadMode"
                      ondblclick="this.select()"
                      :class="{ 'is-invalid': errors.trailer_no }"
                    />

                    <div v-if="errors.trailer_no" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.trailer_no[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Container No -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Container No
                    </label>
                  </div>

                  <div class="col-md-7">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="container_no"
                      :readonly="isExistingLoadMode"
                      ondblclick="this.select()"
                      :class="{ 'is-invalid': errors.container_no }"
                    />

                    <div v-if="errors.container_no" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.container_no[0] }}
                      </div>
                    </div>
                  </div>
                </div>


                 <div class="row align-items-center mb-2" v-show="selectedUnit !== 'Vendor'">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                     Rute Tol
                    </label>
                  </div>

                  <div class="col-md-7">
                    <BaseSelect
                    :disabled="isExistingLoadMode"
                      :options="dropDownRouteTolOptions"
                      :value="selectedRouteTol"
                      label-key="label"
                      :invalid="!!errors.toll_flag"
                      @input="onRouteTolPicked"
                    />


                     <!-- <BaseSelect
                        
                        :options="dropDownCustTujuans"
                        :value="selectedCustTujuan"
                        label-key="value"
                        placeholder="-- Cari & Pilih --"
                        :search-fn="asyncSearchCustTujuan"
                        :invalid="!!errors.cust_tujuan"
                        @input="onCustTujuanPicked"
                      /> -->

                    <div v-if="errors.toll_flag" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.toll_flag[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row align-items-center mb-2">
                  <div class="col-md-3"></div>
                  <div class="col-md-7">
                    <!-- Toast notifikasi muncul DI SINI (bawah customer tujuan) -->
                    <div v-if="showClearToast" class="mt-2">
                      <div
                        class="alert alert-success py-1 px-2 mb-0"
                        role="alert"
                        style="z-index: 1200"
                      >
                        <i data-feather="check-circle"></i>
                        <span class="ms-1">Semua pilihan berhasil dihapus</span>
                      </div>
                    </div>
                  </div>

                  <!-- tombol Clear di kolom paling kanan, hanya muncul kalau ada value -->
                  <div class="col-md-2 d-flex justify-content-end">
                    <button
                      v-if="hasAnyDropdownValue && !isExistingLoadMode"
                      type="button"
                      class="btn btn-danger btn-sm"
                      @click="clearAllDropdowns"
                      title="Clear semua pilihan"
                    >
                      <i data-feather="x-circle"></i>
                      <span class="ms-1 d-none d-md-inline">Clear</span>
                    </button>
                  </div>
                </div>
              </div>
              <!-- ================= end card kanan ================= -->
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div
          class="modal-footer d-flex justify-content-between bg-white border-top"
        >
          <div>
            <button
              v-show="canShowCalculate"
              class="btn btn-success btn-sm"
              type="submit"
              @click="calculateFreightBuilder"
            >
              <span
                v-if="isLoadingCalculate"
                class="spinner-border spinner-border-sm ms-auto me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Calculate
            </button>
            <button
              v-show="
                selectedUnit === 'Shipment to Existing Load' && !isBlujaySent
              "
              class="btn btn-success btn-sm"
              type="submit"
              :disabled="isProcessing"
              @click.prevent="saveShipmentToLoad"
            >
              <span
                v-if="isProcessing"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Simpan & Kirim Ke Blujay
            </button>
          </div>
          <div>
            <button
              v-if="canShowSubmitBtn"
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitLoadEntry"
            >
              <i class="mdi mdi-send me-1"></i> Kirim Ke Blujay
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import BaseSelect from "@/components/slide-panel/BaseSelect.vue";

export default {
  name: "ModalFreightBuilder",
  components: {
    BaseSelect,
  },
  emits: ["closeModal"],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoadingVendorData: false,
      orderTypeFromFreight: null,
      showUnitRadio: false,
      isAfterSubmitSuccess: false,
      canShowSubmitBtn: false,
      vehicleSelectKey: 0,
      typeTruckSelectKey: 0,
      carrierSelectKey: 0,
      vehicle_no_vendor_text: "",
      driver_vendor_text: "",
      vendorVehiclesRaw: [],
      vendorDriversRaw: [],
      trailer_no: null,
      container_no: null,
      transport_order_header_id_max: null,

      marginStatus: false,
      payableStatus: false,
      isProcessing: false,
      isConnectionErrorShown: false,
      transportHeaderIds: [],
      canCalculate: false,
      perPageSlide: 10, // or any default number
      currentPageSlide: 1, // start from 1
      totalPageSlide: 0, // optional kalau dipakai
      closingByChild: false,
      globalMessages: [],

      //!SECTION
      isLoadingPayable: false,
      isLoadingMargin: false,
      isLoadingCalculate: false,
      isLoadingAddShipment: false,
      isLoadingLoadId: false,
      isLoadingDeleteShipment: false,

      dropDownRouteTolOptions: [
        { label: "RUTE TOL", value: "ROUTE-01" },
        { label: "RUTE NON TOLL", value: "ROUTE-02" },
      ],

      isBlujaySent: false,
      showClearToast: false,
      branchName: "",

      autoProcessOptions: [
        { label: "Yes", value: "Yes" },
        { label: "No", value: "No" },
        { label: "Manual", value: "Manual" },
      ],
      autoProcess: "",

      isSearchingLoadIdExist: false,
      loadIdExist: null,
      dropDownLoadIdExists: [],

      isSearchingCustTujuan: false,
      cust_tujuan: null,
      dropDownCustTujuans: [],

      isSearchingDriver: false,
      driver_id: null,
      driver_nmk: null,
      driver_name: null,
      driver_number: null,
      dropDownDrivers: [],

      isSearchingTypeTruck: false,
      type_truck: null,
      dropDownTypeTrucks: [],

      isSearchingTransporter: false,
      carrier_name: null,
      dropDownTransporters: [],

      isSearchingVehicle: false,
      vehicle_no: null,
      vehicle_branch_id: null,
      vehicle_branch_name: null,
      dropDownVehicleNos: [],

      errors: [],
      showTable: true,
      showModalFreightBuilder: false,
      freightRows: [],
      isCalculated: false,
      globalFilter: "",
      showSlidePanel: false,
      selectedSlideIndexes: [],
      selectAllSlide: false,
      columnFilters: {},
      columnListShipments: [
        { label: "No", field: "no", width: "50px" },
        { label: "Shipment Type", field: "shipment_type", width: "120px" },
        { label: "Customer", field: "customer", width: "150px" },
        { label: "Order", field: "order", width: "150px" },
        { label: "ShipWithRef", field: "shipwithref", width: "200px" },
        { label: "Tonase", field: "tonase", width: "100px" },
        { label: "Pickup", field: "pickup", width: "400px" },
        { label: "Drop", field: "drop", width: "400px" },
      ],
      rowListShipments: [], // akan diisi saat modal dibuka
      selectedUnit: "",
    
      payableResult: "",
      marginResult: "",
      loadId: "",
      routeTol:"",
      isLoading: false,
      isLoadingShipmentFB: false,
      isLoadingShipmentListAvailable: false,
      selectAll: false,
      selectedIndexes: [], // index yang dipilih
      columns: [
        { label: "No", field: "no", width: "50px" },
        { label: "Jarak", field: "jarak", width: "100px" },
        { label: "Shipment Type", field: "shipment_type", width: "120px" },
        { label: "Main", field: "__main__", width: "60px" },
        { label: "Customer", field: "customer", width: "150px" },
        { label: "Order", field: "order", width: "150px" },
        { label: "ShipWithRef", field: "shipwithref", width: "200px" },
        { label: "Tonase", field: "tonase", width: "100px" },
        { label: "Pickup", field: "pickup", width: "400px" },
        { label: "Drop", field: "drop", width: "400px" },
      ],
      rows: [],
      totalRecords: 0,
    };
  },
  computed: {
    //!SECTION
    selectedCustTujuan() {
      return (
        this.dropDownCustTujuans.find((o) => o.value === this.cust_tujuan) ||
        null
      );
    },

    selectedRouteTol() {
    return (
      this.dropDownRouteTolOptions.find(
        (o) => o.value === this.routeTol
      ) || null
    );
  },



    //!SECTION
    selectedAutoProcess() {
      return (
        this.autoProcessOptions.find((o) => o.value === this.autoProcess) ||
        null
      );
    },

    //!SECTION
    isTransporterReady() {
      return !!this.carrier_name;
    },

    isTypeTruckReady() {
      return !!this.type_truck;
    },

    canCheckVendorData() {
      return (
        this.isVendorUnit &&
        this.isTransporterReady &&
        this.isTypeTruckReady &&
        !this.isLoadingVendorData
      );
    },

    hasVendorVehicleData() {
      return this.canCheckVendorData && this.dropDownVehicleNos.length > 0;
    },

    hasVendorDriverData() {
      return this.canCheckVendorData && this.dropDownDrivers.length > 0;
    },

    isVendorUnit() {
      return this.selectedUnit === "Vendor";
    },

    isTransporterAndTypeTruckFilled() {
      return !!this.carrier_name && !!this.type_truck;
    },

    isVehicleDriverDisabled() {
      // 🔒 existing load = selalu disable
      if (this.isExistingLoadMode) return true;

      // 🔒 vendor tapi transporter / type truck belum lengkap
      if (this.isVendorUnit && !this.isTransporterAndTypeTruckFilled) {
        return true;
      }

      // ✅ kondisi lain (Own)
      return false;
    },

    transport_order_header_ids() {
      return this.rows
        .map((r) => r.transport_order_header_id)
        .filter(Boolean)
        .join(",");
    },
    totalShipment() {
      return this.rows?.length || 0;
    },
    //!SECTION
    // total record setelah filter
    totalRecordSlide() {
      return this.filteredRows.length;
    },
    // total halaman
    totalPagesSlide() {
      return Math.ceil(this.totalRecordSlide / this.perPageSlide) || 1;
    },
    // dari nomor ke berapa – ke berapa
    startRecordSlide() {
      if (this.totalRecordSlide === 0) return 0;
      return (this.currentPageSlide - 1) * this.perPageSlide + 1;
    },
    endRecordSlide() {
      return Math.min(
        this.startRecordSlide + this.perPageSlide - 1,
        this.totalRecordSlide,
      );
    },
    // data 1 page
    paginatedRowsSlide() {
      const start = (this.currentPageSlide - 1) * this.perPageSlide;
      const end = start + this.perPageSlide;

      const out = this.filteredRows.slice(start, end);

      //console.log("👉 paginatedRowsSlide:", out);

      return out;
    },
    // nomor halaman
    pageNumbersSlide() {
      const pages = [];
      const delta = 2;

      for (
        let i = Math.max(1, this.currentPageSlide - delta);
        i <= Math.min(this.totalPagesSlide, this.currentPageSlide + delta);
        i++
      ) {
        pages.push(i);
      }

      return pages;
    },
    // search
    filteredRows() {
      const term = (this.globalFilter || "").toLowerCase();
      let out = this.rowListShipments;

      if (term) {
        out = out.filter((row) =>
          this.columnListShipments.some((col) =>
            String(row[col.field] || "")
              .toLowerCase()
              .includes(term),
          ),
        );
      }

      //console.log("👉 filteredRows:", out);

      return out;
    },

    //!SECTION
    canShowCalculate() {
      // 0️⃣ Rows kosong → jangan tampilkan tombol
      if (!this.rows || this.rows.length === 0) return false;

      // 1️⃣ Jika sudah dikirim ke BluJay → tombol wajib hilang
      if (this.isBlujaySent) return false;

      // 2️⃣ Safety flag dari proses Sync Distance
      if (!this.canCalculate) return false;

      // 3️⃣ Validasi berdasarkan unit
      if (this.selectedUnit === "Own") {
        return !!(this.vehicle_no && this.vehicle_no.vehicle_no);
      }

      if (this.selectedUnit === "Vendor") {
        return !!(this.type_truck && this.type_truck.type_truck);
      }

      return false;
    },

    //!SECTION
    isExistingLoadMode() {
      return this.selectedUnit === "Shipment to Existing Load";
    },
    hasAnyDropdownValue() {
      // ❌ submit sedang jalan / sudah sukses → hide
      if (!this.canCalculate) return false;
      if (this.isBlujaySent) return false;

      return (
        !!this.carrier_name ||
        !!this.type_truck ||
        !!this.vehicle_no ||
        !!this.driver_id ||
        !!this.autoProcess ||
        !!this.cust_tujuan ||
        !!this.trailer_no ||
        !!this.container_no
      );
    },
    slideHeaderText() {
      if (this.selectedUnit === "Shipment to Existing Load") {
        // kalau ada Load ID terpilih, tampilkan Load ID-nya
        if (this.loadIdExist && this.loadIdExist.load_id) {
          return `Pilih Order untuk dimasukan ke dalam Load ID : ${this.loadIdExist.load_id}`;
        }
        // belum ada load id → tampilkan pesan khusus untuk existing-load (opsional)
        return "Pilih Order untuk dimasukan ke dalam Load ID : ";
      }
      // selain existing load → default proses freight builder
      return "Pilih Order untuk dimasukan ke dalam proses Freight Builder";
    },
  },
  watch: {
    autoProcess() {
      this.buildPayloadLoadEntry();
    },

    routeTol() {
      this.buildPayloadLoadEntry();
    },

    cust_tujuan() {
      this.buildPayloadLoadEntry();
    },
    trailer_no() {
      this.buildPayloadLoadEntry();
    },

    container_no() {
      this.buildPayloadLoadEntry();
    },
    //!SECTION
    driver_nmk() {
      this.buildPayloadLoadEntry();
    },

    driver_id() {
      this.buildPayloadLoadEntry();
    },

    //!SECTION
    transportHeaderIds: {
      deep: true,
      handler() {
        this.triggerSyncDistance();
      },
    },

    //!SECTION
    perPageSlide() {
      this.currentPageSlide = 1;
    },
    globalFilter() {
      this.currentPageSlide = 1;
    },

    //!SECTION
    loadIdExist(newVal) {
      if (!newVal || this.selectedUnit !== "Shipment to Existing Load") {
        this.selectedLoadId = null;
        return;
      }

      // 🔥 object (behavior v-select lama)
      if (typeof newVal === "object" && newVal.load_id) {
        this.selectedLoadId = newVal.load_id;
        this.fillDropdownsFromExistingLoad(newVal.load_id);
        return;
      }

      // 🔥 primitive dari BaseSelect
      const found = this.dropDownLoadIdExists.find((o) => o.load_id === newVal);

      if (found) {
        this.loadIdExist = found; // normalize ke object
        this.selectedLoadId = found.load_id;
        this.fillDropdownsFromExistingLoad(found.load_id);
      }
    },
    branchName(newVal) {
      if (newVal) {
        //console.log("🔁 branchName berubah:", newVal);
        this.loadDriver();
        this.loadVehicleNo();
        this.loadTransporter();
        this.loadTypeTruck();
        this.loadCustTujuan();
      }
    },
    // 🔹 Saat user ganti radio button Unit
    selectedUnit(newVal) {
      // ============================
      // 🔥 STEP 1: KHUSUS VENDOR
      // ============================
      if (newVal === "Vendor") {
        // kosongkan value
        this.vehicle_no = null;
        this.vehicle_no_vendor_text = "";
        this.driver_id = null;
        this.driver_vendor_text = "";

        // kosongkan dropdown
        this.dropDownVehicleNos = [];
        this.dropDownDrivers = [];

        // optional safety flag
        this.isCalculated = false;
        this.isBlujaySent = false;
        this.canCalculate = false;
      }
      // ============================
      // 🔥 STEP 2: UNIT = OWN
      // ============================
      if (newVal === "Own") {
        // 🔁 load ulang master data OWN
        this.loadInitialData();
      }
      this.resetPayloadLoadEntry();
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
      this.payableStatus = false;
      this.marginStatus = false;
      if (this.rows.length <= 1) {
        this.showTable = false; // tampilkan card view
      } else {
        this.showTable = true; // tetap table view
      }
      if (newVal === "Shipment to Existing Load") {
        // ✅ reset Load ID dan semua dropdown
        this.loadIdExist = null;
        this.vehicle_no = null;
        this.vehicle_no_vendor_text = "";
        this.driver_vendor_text = "";
        this.driver_id = null;
        this.type_truck = null;
        this.carrier_name = null;
        this.autoProcess = null;
        this.cust_tujuan = null;
        this.trailer_no = null;
        this.container_no = null;
        this.loadId = "";

        // ✅ reset hasil perhitungan & flag
        this.isBlujaySent = false;
        this.isCalculated = false;
        this.payableResult = "";
        this.marginResult = "";
        this.selectedIndexes = [];
        this.selectAll = false;

        // console.log(
        //   "🔄 Semua data dropdown & hasil kalkulasi direset (karena ganti unit)."
        // );

        // ✅ tampilkan card/table berdasarkan rows saat ini
        this.showTable = this.rows.length > 1;

        // ✅ jika rows masih kosong, load freight data
        if (this.rows.length === 0 && this.data.length > 0) {
          const selected = this.data[0];
          const shipwith_ref = selected.shipwith_ref;
          if (shipwith_ref) {
            this.loadFreightData(shipwith_ref);
          }
        }

        // ✅ load daftar Load ID dari API
        if (this.loadLoadIdExist) {
          this.loadLoadIdExist();
        }
      } else {
        // ✅ reset Load ID dan semua dropdown
        this.loadIdExist = null;
        this.selectedLoadId = null;
        this.vehicle_no = null;
        this.vehicle_no_vendor_text = "";
        this.driver_vendor_text = "";
        this.driver_id = null;
        this.type_truck = null;
        this.carrier_name = null;
        this.autoProcess = null;
        this.cust_tujuan = null;
        this.trailer_no = null;
        this.container_no = null;
        this.loadId = "";

        // ✅ reset hasil perhitungan & flag
        this.isBlujaySent = false;
        this.isCalculated = false;
        this.payableResult = "";
        this.marginResult = "";
        this.selectedIndexes = [];
        this.selectAll = false;

        // console.log(
        //   "🔄 Semua data dropdown & hasil kalkulasi direset (karena ganti unit)."
        // );
      }
    },

    // 🔹 Saat modal dibuka
    async showModal(newVal) {
      this.clearErrorMessages();
      if (!newVal) return;

      // reset tampilan awal
      this.showTable = true;
      this.rows = [];
      this.loadId = "";
      this.selectedUnit = "Own";
      this.selectedIndexes = [];
      this.selectAll = false;

      // reset dropdown
      this.carrier_name = null;
      this.type_truck = null;
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.driver_vendor_text = "";
      this.driver_id = null;
      this.autoProcess = null;
      this.cust_tujuan = null;
      this.trailer_no = null;
      this.container_no = null;

      this.resetAllData();

      // reset slide panel
      this.showSlidePanel = false;
      this.selectedSlideIndexes = [];
      this.selectAllSlide = false;

      // load shipment list
      this.loadShipmentListAvailable();

      // load freight data pertama
      if (this.data.length > 0) {
        console.log("DATA EXIST ✅", JSON.stringify(this.data, null, 2));

        const selected = this.data[0];
        console.log("SELECTED ROW:", JSON.stringify(selected, null, 2));

        const shipwith_ref = selected.shipwith_ref;
        console.log("SHIPWITH_REF:", shipwith_ref);

        if (shipwith_ref) {
          await this.loadFreightData(shipwith_ref);
          this.loadInitialData();
        }

        // 🔥 log parameter sebelum load vehicle
        const company_id = selected?.company_id;
        const billable_method = selected?.billable_tariff;
        const type_truck = selected?.type_truck;
        const truck_no = selected?.truck_no;

        console.log(
          "LOAD VEHICLE PARAMS:",
          JSON.stringify(
            {
              company_id,
              billable_method,
              type_truck,
              truck_no,
            },
            null,
            2,
          ),
        );

        // 🔥 panggil API
        await this.loadVehicleNoLumpsum(
          company_id,
          billable_method,
          type_truck,
          truck_no,
        );
      } else {
        console.warn("DATA EMPTY ❌ this.data.length = 0");
      }
    },

    carrier_name(newVal) {
      console.log("carrier_name selected:", newVal);
      if (this.selectedUnit === "Vendor" && newVal && this.type_truck) {
        this.handleVendorReady();
      }
    },

    type_truck(newVal) {
      this.buildPayloadLoadEntry();

      if (this.selectedUnit === "Vendor") {
        this.resetMainSelection();
        this.triggerSyncDistance();

        if (newVal && this.carrier_name) {
          this.handleVendorReady();
        }
      }
    },

    vehicle_no_vendor_text() {
      this.buildPayloadLoadEntry();
    },
    driver_vendor_text() {
      this.buildPayloadLoadEntry();
    },

    vehicle_no(val) {
      console.log("👀 WATCH vehicle_no =", val);
      this.buildPayloadLoadEntry();
      if (this.selectedUnit === "Own") {
        this.resetMainSelection();
        this.triggerSyncDistance();
      }
    },

    // 🔹 Sinkronisasi ulang lebar scrollbar atas
    rows() {
      this.buildPayloadLoadEntry();
      this.resetMainSelection();

      this.$nextTick(() => {
        this.syncScrollWidths();

        // ============================
        // 🔥 TABLE / CARD VIEW
        // ============================
        this.showTable = this.rows.length > 1;

        // ============================
        // 🔥 NORMALIZER shipment_type
        // ============================
        const normalizeShipmentType = (val) =>
          (val || "")
            .replace(/<[^>]*>/g, "") // buang HTML tag
            .trim()
            .toUpperCase();

        // ============================
        // 🔥 DEFAULT AMAN
        // ============================
        if (this.rows.length === 0) {
          this.showUnitRadio = true;
          return;
        }

        // ============================
        // 🔥 CASE: 1 ROW
        // ============================
        if (this.rows.length === 1) {
          const type = normalizeShipmentType(this.rows[0].shipment_type);

          const isMainOrBackhaul =
            type.includes("MAIN") || type.includes("BACKHAUL");

          // show / hide radio Own & Vendor
          this.showUnitRadio = isMainOrBackhaul;

          // 🔥 TAMBAHAN BARU
          // kalau hide → paksa pilih Shipment to Existing Load
          if (!this.showUnitRadio) {
            this.selectedUnit = "Shipment to Existing Load";
          }

          return;
        }

        // ============================
        // 🔥 CASE: > 1 ROW
        // ============================
        const hasMainOrBackhaul = this.rows.some((row) => {
          const type = normalizeShipmentType(row.shipment_type);
          return type.includes("MAIN") || type.includes("BACKHAUL");
        });

        // show / hide radio Own & Vendor
        this.showUnitRadio = hasMainOrBackhaul;

        // 🔥 TAMBAHAN BARU
        // kalau semua bukan MAIN/BACKHAUL → paksa Shipment to Existing Load
        if (!this.showUnitRadio) {
          this.selectedUnit = "Shipment to Existing Load";
        }
      });
    },
  },
  methods: {
    isFilterableColumn(field) {
      return ["customer", "order", "shipwithref", "pickup", "drop"].includes(
        field,
      );
    },

    applyColumnFilter() {
      this.currentPageSlide = 1;
      this.loadShipmentListAvailable();
    },

    onClearLoadIdExist() {
      this.loadIdExist = null;
    },

    //!SECTION
    onCustTujuanPicked(item) {
      this.cust_tujuan = item ? item.value : null;
    },

    onRouteTolPicked(item) {
  this.routeTol = item ? item.value : null;
},

    //!SECTION
    onAutoProcessPicked(option) {
      this.autoProcess = option ? option.value : "";
    },

    //!SECTION
    isMainDisabled(row) {
      const type = (row.shipment_type || "")
        .replace(/<[^>]*>/g, "")
        .trim()
        .toUpperCase();

      return type !== "MAIN";
    },

    onMainChange(row) {
      const id = row.transport_order_header_id;

      // klik ulang row yang sama → toggle off
      if (this.transport_order_header_id_max === id) {
        this.transport_order_header_id_max = null;
      } else {
        // klik row lain → pindahkan MAIN
        this.transport_order_header_id_max = id;
      }

      this.canShowSubmitBtn = false;

      this.buildPayloadLoadEntry();
    },

    resetMainSelection() {
      if (!Array.isArray(this.rows)) return;

      this.rows.forEach((row) => {
        row._highlight = false;
        row.transport_order_header_id_max = null;
        row.is_main_checked = false;
      });

      this.transport_order_header_id_max = null;
    },

    //!SECTION
    triggerSyncDistance() {
      this.isBlujaySent = false;
      this.isCalculated = false;
      // Jika tidak ada rows → jangan trigger
      if (!this.rows || this.rows.length === 0) return;

      // OWN → WAJIB vehicle_no
      if (this.selectedUnit === "Own") {
        if (!this.vehicle_no?.vehicle_no) return;
      }

      // Vendor → WAJIB type_truck
      if (this.selectedUnit === "Vendor") {
        if (!this.type_truck?.type_truck) return;
      }

      // Shipment to Existing Load → skip
      if (this.selectedUnit === "Shipment to Existing Load") return;

      // Kalau semua valid → jalankan debounce sync
      this.debouncedSyncDistance();
    },

    async syncDistance() {
      this.clearErrorMessages();
      this.isProcessing = true;

      try {
        // ============================
        // 1️⃣ VALIDASI SEBELUM KIRIM API
        // ============================
        this.errors = {};

        if (this.selectedUnit === "Own") {
          // OWN → vehicle_no wajib
          if (!this.vehicle_no) {
            this.errors.vehicle_no = ["Vehicle No wajib diisi untuk unit Own"];
            this.isProcessing = false;
            return;
          }
        }

        if (this.selectedUnit === "Vendor") {
          if (!this.type_truck) {
            this.errors.type_truck = ["Type Truck wajib diisi untuk Vendor"];
          }

          if (Object.keys(this.errors).length > 0) {
            this.isProcessing = false;
            return;
          }
        }

        // ============================
        // 2️⃣ SUSUN PAYLOAD SESUAI DOK API
        // ============================
        const payload = {
          vehicle_no:
            this.selectedUnit === "Own"
              ? this.vehicle_no?.vehicle_no || null
              : null, // Vendor → null

          type_truck: this.type_truck?.type_truck || null,

          transport_order_header_ids: this.rows
            .map((r) => r.transport_order_header_id)
            .filter(Boolean)
            .join(","),
        };

        //console.log("🔵 [Sync Distance] Payload:", payload);

        // ============================
        // 3️⃣ CALL API
        // ============================
        const url = `${this.$settings.endPoint}/control-tower/transport-order-header/sync-distance`;
        const response = await this.$http.post(url, payload);

        // ============================
        // 4️⃣ SUCCESS
        // ============================
        this.isProcessing = false;
        this.isConnectionErrorShown = false;

        //console.log("🟢 [Sync Distance] Response:", response);

        const msg = response.data?.datas?.messages || "Sync Distance Success";

        this.showGlobalMessage("success", msg, "Sync Distance");

        // Refresh jarak
        this.refreshFreightBuilder();

        // Enable tombol Calculate
        this.canCalculate = true;
      } catch (error) {
        this.isProcessing = false;
        this.canCalculate = false;

        //console.error("🔴 [Sync Distance] Error:", error);

        // Gunakan handler error global
        this.handleApiError(error, "Sync Distance");
      }
    },

    //!SECTION
    resetAllData() {
      this.rows = [];
      this.rowListShipments = [];
      this.selectedIndexes = [];
      this.selectedSlideIndexes = [];
      this.selectAll = false;
      this.selectAllSlide = false;
      this.payableResult = "";
      this.marginResult = "";
      this.loadId = "";
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.isLoading = false;
      this.isLoadingLoadId = false;
      this.showTable = true;
      this.showSlidePanel = false;
      this.payableStatus = false;
      this.marginStatus = false;
      this.selectedUnit = "Own";
      this.errors = [];
      this.resetPayloadLoadEntry();
    },
    clearAllDropdowns() {
      // kosongkan semua dropdown (Transporter → Customer Tujuan)
      this.canShowSubmitBtn = false;
      this.carrier_name = null;
      this.type_truck = null;
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.driver_vendor_text = "";
      this.driver_id = null;
      this.autoProcess = null;
      this.cust_tujuan = null;
      this.trailer_no = null;
      this.container_no = null;

      // tampilkan toast (di bawah Customer Tujuan)
      this.showClearToast = true;
      setTimeout(() => {
        this.showClearToast = false;
      }, 2000);

      // refresh feather icon (agar ikon tampil / ter-replace)
      this.$nextTick(() => {
        if (window.feather) window.feather.replace();
      });
    },

    //!SECTION
    asyncSearchLoadIdExist(searchQuery) {
      this.isSearchingLoadIdExist = true;
      const baseURI = `${this.$settings.endPoint}control-tower/transport-order-header/existing-load?limit=10&load_id=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          const data = response.data?.datas || [];
          this.dropDownLoadIdExists = data.map((item) => ({
            load_id: item.load_id,
            vehicle_no: item.vehicle_no,
            driver: `${item.driver_id || ""} - ${item.driver_name || ""} - ${
              item.driver_number || ""
            }`,
            type_truck: item.type_truck,
            carrier: item.carrier,
            auto_load: item.auto_load,
            remarks: item.remarks,
            cust_tujuan: item.remarks,
            container_no: item.container,
            trailer_no: item.trailer_no,
            label: `${item.load_id} - ${item.order_status} - ${
              item.type_truck
            } - ${item.name || ""}
            `,
          }));
        })
        .finally(() => {
          this.isSearchingLoadIdExist = false;
        });
    },
    loadLoadIdExist() {
      const baseURI = `${this.$settings.endPoint}control-tower/transport-order-header/existing-load?limit=10`;
      return this.$http.get(baseURI).then((response) => {
        const data = response.data?.datas || [];
        this.dropDownLoadIdExists = data.map((item) => ({
          load_id: item.load_id,
          vehicle_no: item.vehicle_no,
          driver: `${item.driver_id || ""} - ${item.driver_name || ""} - ${
            item.driver_number || ""
          }`,
          type_truck: item.type_truck,
          carrier: item.carrier,
          auto_load: item.auto_load,
          cust_tujuan: item.remarks,
          container_no: item.container,
          trailer_no: item.trailer_no,
          label: `${item.load_id} - ${item.order_status} - ${
            item.type_truck
          } - ${item.name || ""}`,
        }));
      });
    },
    handleLoadIdExistChange(value) {
      if (!value) {
        this.loadIdExist = null; // watcher yang handle reset
      }
    },
    fillDropdownsFromExistingLoad(loadId) {
      const selectedLoad = this.dropDownLoadIdExists.find(
        (item) => item.load_id === loadId,
      );

      if (!selectedLoad) {
        //console.warn("⚠️ Load ID tidak ditemukan:", loadId);
        return;
      }
      // ✅ Container No
      this.container_no =
        typeof selectedLoad.container_no === "object"
          ? selectedLoad.container_no?.container_no || ""
          : selectedLoad.container_no || "";

      // ✅ Trailer No
      this.trailer_no =
        typeof selectedLoad.trailer_no === "object"
          ? selectedLoad.trailer_no?.trailer_no || ""
          : selectedLoad.trailer_no || "";

      // ✅ Vehicle No
      this.vehicle_no = selectedLoad.vehicle_no
        ? { vehicle_no: selectedLoad.vehicle_no }
        : null;

      // ✅ Driver
      this.driver_id = selectedLoad.driver
        ? {
            driver_name: selectedLoad.driver,
            driver_id: selectedLoad.driver_id || null,
            driver_number: selectedLoad.driver_number || null,
          }
        : null;

      // ✅ Type Truck
      this.type_truck = selectedLoad.type_truck
        ? { type_truck: selectedLoad.type_truck }
        : null;

      // ✅ Transporter
      this.carrier_name = selectedLoad.carrier
        ? { carrier_name: selectedLoad.carrier }
        : null;

      // ✅ Auto Process (fix: pakai string, bukan object)
      if (selectedLoad.auto_load) {
        const normalized = selectedLoad.auto_load.trim().toLowerCase();
        if (normalized === "yes" || normalized === "y")
          this.autoProcess = "Yes";
        else if (normalized === "no" || normalized === "n")
          this.autoProcess = "No";
        else if (normalized === "manual" || normalized === "m")
          this.autoProcess = "Manual";
        else this.autoProcess = null;
      } else {
        this.autoProcess = null;
      }

      // ✅ Customer Tujuan (fix: gunakan cust_tujuan)
      if (selectedLoad.cust_tujuan) {
        // 🔹 Bersihkan karakter ";" jadi ""
        const val = selectedLoad.cust_tujuan.replace(/;/g, "- ").trim();

        // Tambahkan ke dropdown kalau belum ada
        const exists = this.dropDownCustTujuans.some((c) => c.value === val);
        if (!exists && val !== "") {
          this.dropDownCustTujuans.push({ value: val });
        }

        // Set value ke dropdown
        this.cust_tujuan = val;
      } else {
        this.cust_tujuan = null;
      }

      //console.log("✅ Data dropdown berhasil diisi:", selectedLoad);
    },
    async saveShipmentToLoad() {
      this.isProcessing = true;
      this.clearErrorMessages?.();

      try {
        // =======================
        // 🔍 FRONTEND VALIDATION
        // =======================
        const errors = {};

        if (!this.selectedLoadId) {
          errors.load_id = ["Load ID wajib diisi."];
        }

        const shipmentIds = this.transport_order_header_ids;

        if (!shipmentIds) {
          errors.shipment = ["Minimal 1 shipment harus dipilih."];
        }

        if (Object.keys(errors).length > 0) {
          throw {
            response: {
              status: 422,
              data: {
                message: "Validation Error",
                errors,
              },
            },
            isFrontendValidation: true,
          };
        }

        // =======================
        // 🟩 PAYLOAD
        // =======================
        const payload = {
          transport_order_header_ids: shipmentIds, // "3224,3225"
          load_id: this.selectedLoadId, // existing load
          toll_flag:this.routeTol||null,
        };

        console.log(
          "📦 payload saveShipmentToLoad :",
          JSON.stringify(payload, null, 2),
        );

        //return;

        // =======================
        // 🟩 BE CALL
        // =======================
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/existing-load`;
        const res = await this.$http.post(url, payload);

        this.handleLogicalError?.(res);

        const loadId = res.data?.datas?.load_id;

        // =======================
        // ✅ SUCCESS
        // =======================
        await Swal.fire({
          title: "Shipment to Existing Load",
          text: `${res.data?.datas?.messages}`,
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
          allowOutsideClick: false,
          allowEscapeKey: true,
        });
        this.isBlujaySent = true;

        return { ok: true, load_id: loadId };
      } catch (error) {
        // =======================
        // ❌ ERROR HANDLING
        // =======================
        const status = error?.response?.status;

        if (status === 422) {
          this.handleApiError(error, "Shipment to Existing Load");
          return { ok: false, validation: true };
        }

        this.handleApiError(error, "Shipment to Existing Load");
        return { ok: false };
      } finally {
        this.isProcessing = false;
      }
    },

    //!SECTION
    asyncSearchCustTujuan(searchQuery) {
      this.isSearchingCustTujuan = true;
      const baseURI = `${this.$settings.endPointCt}master-lookup/index-view?unique_id=custan&limit=10&value=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownCustTujuans = response.data.datas.data;
        })
        .finally(() => {
          this.isSearchingCustTujuan = false;
        });
    },
    loadCustTujuan() {
      const baseURI = `${this.$settings.endPointCt}master-lookup/index-view?unique_id=custan&limit=10`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownCustTujuans = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    //!SECTION
    onDriverPicked(val) {
      this.driver_id = val;

      // 🔥 MAP KE PAYLOAD
      this.driver_nmk = val?.driver_id || null;
      this.driver_name = val?.driver_name || null;
      this.driver_number = val?.driver_number || null;

      // 🔍 CONSOLE DEBUG
      //console.log("🧑‍✈️ DRIVER PICKED");
      //console.log("  driver_nmk     :", this.driver_nmk);
      //console.log("  driver_name    :", this.driver_name);
      //console.log("  driver_number  :", this.driver_number);
      //console.log("  full object    :", val);
    },
    onClearDriver() {
      this.driver_id = null;

      this.driver_nmk = null;
      this.driver_name = null;
      this.driver_number = null;

      //console.log("🧹 DRIVER CLEARED");
      //console.log("  driver_nmk    :", this.driver_nmk);
      //console.log("  driver_name   :", this.driver_name);
      //console.log("  driver_number :", this.driver_number);
    },
    filterDriverOptions(option, label, search) {
      const s = search.toLowerCase();
      return (
        (option.driver_name && option.driver_name.toLowerCase().includes(s)) ||
        (option.driver_number &&
          option.driver_number.toLowerCase().includes(s)) ||
        (option.driver_id && option.driver_id.toLowerCase().includes(s))
      );
    },
    customLabelDriver(ev) {
      if (!ev) return "";

      // 🔥 VENDOR
      if (this.selectedUnit === "Vendor") {
        return [ev.driver_number, ev.driver_name, ev.sob_status]
          .filter(Boolean)
          .join(" - ");
      }

      // 🔥 OWN / DEFAULT
      return [ev.driver_id, ev.driver_name, ev.driver_number]
        .filter(Boolean)
        .join(" - ");
    },
    asyncSearchDriver(searchQuery) {
      if (this.selectedUnit === "Vendor") {
        const s = searchQuery.toLowerCase();

        this.dropDownDrivers = this.vendorDriversRaw.filter(
          (d) =>
            d.driver_name.toLowerCase().includes(s) ||
            d.driver_number.toLowerCase().includes(s),
        );

        return; // ❌ STOP — NO API
      }
      this.isSearchingDriver = true;
      const baseURI = `${this.$settings.endPointCt}master-driver/select?limit=10&driver_id=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownDrivers = response.data.datas.data;
        })
        .finally(() => {
          this.isSearchingDriver = false;
        });
    },
    loadDriver() {
      if (this.selectedUnit === "Vendor") return;
      // Gunakan nilai branchName yang sudah diset dari loadFreightData
      const branch = this.branchName ? encodeURIComponent(this.branchName) : "";
      // console.log("loadDriver " + JSON.stringify(branch, null, 2));

      const baseURI = `${this.$settings.endPointCt}master-driver/select-freepick?branch=${branch}&limit=10`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          const allDrivers = response.data.datas.data || [];
          this.dropDownDrivers = allDrivers.filter(
            (d, i, arr) =>
              arr.findIndex((x) => x.driver_id === d.driver_id) === i,
          );
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            const status = error.response.status;
            if (status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (status === 500) {
              this.$router.push("/server-error");
            } else if (status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    //!SECTION
    asyncSearchTypeTruck(searchQuery) {
      this.isSearchingTypeTruck = true;
      const baseURI = `${this.$settings.endPointCt}type-truck?select=select&limit=10&type_truck=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownTypeTrucks = response.data.datas.data;
          //console.log('dropDownTypeTrucks ' + JSON.stringify(response.data.datas.data, null, 2));
        })
        .finally(() => {
          this.isSearchingTypeTruck = false;
        });
    },
    loadTypeTruck() {
      const baseURI = `${this.$settings.endPointCt}type-truck?select=select&limit=10`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownTypeTrucks = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    onClearTypeTruck() {
      this.type_truck = null;
      this.typeTruckSelectKey++;
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
    },
    onTypeTruckPicked(val) {
      this.type_truck = val;
      this.typeTruckSelectKey++;
      this.isCalculated = false;
      this.isBlujaySent = false;
    },

    //!SECTION
    asyncSearchTransporter(searchQuery) {
      this.isSearchingTransporter = true;
      const baseURI = `${this.$settings.endPointCt}master-carrier?limit=10&carrier_name=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          const allData = response.data.datas.data || [];

          // 🔹 Ambil hanya transporter yang carrier_code bukan 0000 atau 0001
          this.dropDownTransporters = allData.filter(
            (item) =>
              item.carrier_code !== "0000" &&
              item.carrier_code !== "0001" &&
              item.carrier_code !== "0027",
          );

          // console.log(
          //   "Filtered Transporter (search):",
          //   this.dropDownTransporters
          // );
        })
        .finally(() => {
          this.isSearchingTransporter = false;
        });
    },
    loadTransporter() {
      const baseURI = `${this.$settings.endPointCt}master-carrier?status=active&limit=10`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          const allData = response.data.datas.data || [];

          // 🔹 Ambil hanya transporter yang carrier_code bukan 0000 atau 0001
          this.dropDownTransporters = allData.filter(
            (item) =>
              item.carrier_code !== "0000" &&
              item.carrier_code !== "0001" &&
              item.carrier_code !== "0027",
          );
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    onClearCarrierName() {
      this.carrier_name = null;
      this.carrierSelectKey++;
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
    },
    onCarrierPicked(val) {
      this.carrier_name = val;
      this.carrierSelectKey++;
      this.isCalculated = false;
      this.isBlujaySent = false;
    },

    //!SECTION
    onClearVehicleNo() {
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.vehicleSelectKey++;

      // 🔥 RESET BRANCH
      this.vehicle_branch_id = null;
      this.vehicle_branch_name = null;

      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;

      // console.log("🧹 VEHICLE CLEARED");
      // console.log("  branch_id   :", this.vehicle_branch_id);
      // console.log("  branch_name :", this.vehicle_branch_name);
    },
    onVehiclePicked(val) {
      console.log("🟡 onVehiclePicked VAL =", val);
      console.log("🟡 typeof val =", typeof val);

      this.vehicle_no = val;

      this.vehicle_branch_id = val?.branch_id ?? null;
      this.vehicle_branch_name = val?.branch_name ?? null;

      console.log(
        "🟢 SET BRANCH:",
        this.vehicle_branch_id,
        this.vehicle_branch_name,
      );
    },
    asyncSearchVehicleNo(searchQuery) {
      if (this.selectedUnit === "Vendor") {
        const s = searchQuery.toLowerCase();
        const type = this.type_truck?.type_truck;

        this.dropDownVehicleNos = this.vendorVehiclesRaw
          .filter(
            (t) =>
              (!type || t.truck_type === type) &&
              t.vehicle_no.toLowerCase().includes(s),
          )
          .map((t) => ({
            vehicle_no: t.vehicle_no,
            truck_type: t.truck_type,
            vehicle_status: `${t.vehicle_no} - ${t.sob_status}`,
            sob_status: t.sob_status,
          }));

        return; // ❌ STOP — NO API
      }
      const userDatas = this.$getUserInfo();
      const role = userDatas?.sub?.role || {};

      this.fetchVehicleNo = [];
      const role_truck_permission = role.role_truck_permission || [];

      // 🔥 console JSON string role permission
      console.log(
        "ROLE TRUCK PERMISSION:",
        JSON.stringify(role_truck_permission, null, 2),
      );

      this.isSearchingVehicle = true;

      // =======================
      // 🔥 ROLE-BASED FILTER
      // =======================
      if (role_truck_permission.length > 0) {
        role_truck_permission.forEach((item) => {
          const vehicle_no = item?.master_truck?.vehicle_no || "";

          if (
            vehicle_no &&
            vehicle_no.toLowerCase().includes(searchQuery.toLowerCase())
          ) {
            this.fetchVehicleNo.push({
              vehicle_no,
              vehicle_status: item.master_truck.vehicle_status,
              branch_id: item.master_truck.branch_id,
              branch_name: item.master_truck.branch_name,
            });
          }
        });

        // 🔥 inject ke dropdown
        this.dropDownVehicleNos = this.fetchVehicleNo;
        console.log("📦 DROPDOWN VEHICLE (LOAD):", this.dropDownVehicleNos);
        this.isSearchingVehicle = false;
        return;
      }

      // =======================
      // 🔥 FALLBACK API
      // =======================
      const baseURI = `${this.$settings.endPointCt}master-truck/index-status?limit=10&vehicle_no=${searchQuery}`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownVehicleNos = response.data.datas.data.map((v) => ({
            vehicle_no: v.vehicle_no,
            vehicle_status: v.vehicle_status,
            branch_id: v.branch_id,
            branch_name: v.branch_name,
          }));
          console.log("📦 DROPDOWN VEHICLE (SEARCH):", this.dropDownVehicleNos);
        })
        .finally(() => {
          this.isSearchingVehicle = false;
        });
    },
    loadVehicleNo() {
      if (this.selectedUnit === "Vendor") return;
      const userDatas = this.$getUserInfo();
      const role = userDatas?.sub?.role || {};

      this.fetchVehicleNo = [];
      const role_truck_permission = role.role_truck_permission || [];

      // 🔥 console JSON string role permission
      console.log(
        "ROLE TRUCK PERMISSION (loadVehicleNo):",
        JSON.stringify(role_truck_permission, null, 2),
      );

      // =======================
      // 🔥 ROLE-BASED MODE
      // =======================
      if (role_truck_permission.length > 0) {
        role_truck_permission.forEach((item) => {
          const truck = item?.master_truck;
          if (!truck) return;

          this.fetchVehicleNo.push({
            vehicle_no: truck.vehicle_no,
            vehicle_status: truck.vehicle_status,
            type_truck_id: truck.type_truck_id,
            branch_id: truck.branch_id,
            branch_name: truck.branch_name,
          });
        });

        // inject ke dropdown
        this.dropDownVehicleNos = this.fetchVehicleNo;
        console.log("📦 DROPDOWN VEHICLE (LOAD):", this.dropDownVehicleNos);
        return;
      }

      // =======================
      // 🔥 FALLBACK API MODE
      // =======================
      const baseURI = `${this.$settings.endPointCt}master-truck/index-status?limit=10`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownVehicleNos = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    loadVehicleNoLumpsum(company_id, billable_method, type_truck, truck_no) {
      const USE_DUMMY = false;

      // 🔥 FORCE STRING (NULL / UNDEFINED → "")
      const companyId = company_id ?? "";
      const billableMethod = billable_method ?? "";
      const typeTruck = type_truck ?? "";
      const truckNo = truck_no ?? "";

      // =======================
      // 🔥 DUMMY MODE
      // =======================
      if (USE_DUMMY) {
        const dummyVehicle = {
          vehicle_no: "B9954UYI",
          type_truck: "L300_BOX",
          vehicle_status: "B9954UYI - AVAILABLE",
          branch_id: 1,
          branch_name: "JAKARTA",
        };

        this.dropDownVehicleNos = [dummyVehicle];
        this.vehicle_no = dummyVehicle;

        // 🔥 SYNC BRANCH
        this.vehicle_branch_id = dummyVehicle.branch_id;
        this.vehicle_branch_name = dummyVehicle.branch_name;

        return Promise.resolve({
          data: { datas: dummyVehicle },
        });
      }

      // =======================
      // 🔥 BACKEND MODE
      // =======================
      const baseURI =
        this.$settings.endPoint +
        `rm-master-truck-lumpsum/vehicle-no` +
        `?company_id=${companyId}` +
        `&billable_method=${billableMethod}` +
        `&type_truck=${typeTruck}` +
        `&truck_no=${truckNo}`;

      console.log("🌐 HIT LUMPSUM API:", baseURI);

      return this.$http
        .get(baseURI)
        .then((response) => {
          const res = response.data?.datas;

          const item = res
            ? {
                vehicle_no: res.vehicle_no ?? "",
                type_truck: res.type_truck ?? typeTruck,
                vehicle_status: res.vehicle_status ?? "", // ✅ FULL BACKEND
                branch_id: res.branch_id ?? null,
                branch_name: res.branch_name ?? null,
              }
            : null;

          this.dropDownVehicleNos = item?.vehicle_no ? [item] : [];
          this.vehicle_no = item?.vehicle_no ? item : null;

          // 🔥 SYNC BRANCH
          this.vehicle_branch_id = item?.branch_id ?? null;
          this.vehicle_branch_name = item?.branch_name ?? null;

          console.log("🚚 LUMPSUM VEHICLE:", this.vehicle_no);
          console.log(
            "🏢 BRANCH:",
            this.vehicle_branch_id,
            this.vehicle_branch_name,
          );

          return response;
        })
        .catch((error) => {
          // 🔥 RESET STATE BIAR UI AMAN
          this.dropDownVehicleNos = [];
          this.vehicle_no = null;
          this.vehicle_no_vendor_text = "";
          this.vehicle_branch_id = null;
          this.vehicle_branch_name = null;

          // =======================
          // 🔥 SAME ERROR HANDLING
          // =======================
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    loadForCarrier(code) {
      const baseURI =
        this.$settings.endPointCt +
        `master-carrier/?carrier_code=${code}&status=active`;

      return this.$http.get(baseURI).then((response) => {
        const carrier = response.data.datas?.data?.[0];
        if (!carrier) return;

        this.transporter = carrier;

        // 🔥 RAW DATA (UNTUK SEARCH)
        this.vendorDriversRaw = carrier.driver || [];
        this.vendorVehiclesRaw = carrier.truck || [];

        // 🔥 DRIVER DROPDOWN
        this.dropDownDrivers = this.vendorDriversRaw.map((d) => ({
          driver_id: d.driver_number,
          driver_number: d.driver_number,
          driver_name: d.driver_name,
          sob_status: d.sob_status,
        }));

        // 🔥 VEHICLE DROPDOWN (BELUM FILTER TYPE)
        this.dropDownVehicleNos = this.vendorVehiclesRaw.map((t) => ({
          vehicle_no: t.vehicle_no,
          truck_type: t.truck_type,
          vehicle_status: `${t.vehicle_no} - ${t.sob_status}`,
          sob_status: t.sob_status,
          branch_id: t.branch_id,
          branch_name: t.branch_name,
        }));

        this.vehicle_no = null;
        this.vehicle_no_vendor_text = "";
        this.driver_vendor_text = "";
        this.driver_id = null;
      });
    },
    async handleVendorReady() {
      // safety guard
      if (this.selectedUnit !== "Vendor") return;
      if (!this.carrier_name || !this.type_truck) return;

      const carrierCode = this.carrier_name?.carrier_code;
      if (!carrierCode) return;

      this.isLoadingVendorData = true;

      // reset dulu
      this.vehicle_no = null;
      this.driver_id = null;
      this.driver_vendor_text = "";
      this.vehicle_no_vendor_text = "";
      this.dropDownVehicleNos = [];
      this.dropDownDrivers = [];

      try {
        await this.loadForCarrier(carrierCode);
      } catch (err) {
        console.error("Vendor load error:", err);
      }

      this.isLoadingVendorData = false;
    },
    cekDataTypeTruck(ev) {
      if (this.selectedUnit !== "Vendor") return;

      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";

      const type = ev?.type_truck;
      if (!type) {
        this.dropDownVehicleNos = [];
        return;
      }

      this.dropDownVehicleNos = this.vendorVehiclesRaw
        .filter((t) => t.truck_type === type)
        .map((t) => ({
          vehicle_no: t.vehicle_no,
          truck_type: t.truck_type,
          vehicle_status: `${t.vehicle_no} - ${t.sob_status}`,
          sob_status: t.sob_status,
        }));
    },

    //!SECTION
    goToPageSlide(page) {
      this.currentPageSlide = page;
    },
    prevPageSlide() {
      if (this.currentPageSlide > 1) this.currentPageSlide--;
    },
    nextPageSlide() {
      if (this.currentPageSlide < this.totalPagesSlide) this.currentPageSlide++;
    },

    //!SECTION
    async loadInitialData() {
      await this.loadVehicleNo();
      await this.loadTransporter();
      await this.loadTypeTruck();
      await this.loadCustTujuan();
      await this.loadLoadIdExist();
      if (this.branchName) {
        await this.loadDriver();
      } else {
        //console.warn("⚠️ branchName masih kosong, loadDriver dilewati");
      }
    },
    async loadShipmentListAvailable() {
      this.isLoadingShipmentListAvailable = true;

      try {
        const params = {
          limit: this.perPageSlide,
          page: this.currentPageSlide,

          // 🔥 COLUMN FILTER → BE
          company_name: this.columnFilters.customer || null,
          order_no: this.columnFilters.order || null,
          shipwith_ref: this.columnFilters.shipwithref || null,
          pick_name: this.columnFilters.pickup || null,
          dest_name: this.columnFilters.drop || null,
        };

        const url = `${this.$settings.endPoint}control-tower/transport-order-header/shipment-available`;

        const res = await this.$http.get(url, {
          params,
          timeout: 10000,
        });

        let datas = res.data?.datas?.data || [];

        // tetap pakai logic lama
        if (this.orderTypeFromFreight) {
          datas = datas.filter(
            (item) =>
              item.transport_order_template?.order_type ===
              this.orderTypeFromFreight,
          );
        }

        const existingIds = this.transport_order_header_ids
          ? this.transport_order_header_ids.split(",")
          : [];

        datas = datas.filter(
          (item) =>
            !existingIds.includes(String(item.transport_order_header_id)),
        );

        this.rowListShipments = datas.map((item, i) => {
          return {
            originalIndex: i,
            no: i + 1,
            transport_order_header_id: item.transport_order_header_id,
            shipment_type:
              item.shipment_type === "MAIN"
                ? `<span class="shipment-main">MAIN</span>`
                : item.shipment_type || "",
            customer: item.company?.name || "",
            order: item.order_no || "",
            shipwithref: item.shipwith_ref || "",
            tonase: item.tonnage
              ? `${item.tonnage
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")} Kg`
              : "",
            pickup: `<div>${item.pick_plan || ""}</div><div>${
              item.pick_name || ""
            }</div>`,
            drop: `<div>${item.dest_plan || ""}</div><div>${
              item.dest_name || ""
            }</div>`,
          };
        });
      } catch (e) {
        console.error("Error loading shipment:", e);
        const result = this.handleApiError(e, "Refresh Freight Builder");

        return result;
      } finally {
        this.isLoadingShipmentListAvailable = false;
      }
    },

    async loadFreightData(shipwith_ref) {
      this.isLoadingShipmentFB = true;
      try {
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/mass-freight-builder/${shipwith_ref}`;

        const res = await this.$http.get(url, { timeout: 10000 });
        const datas = res.data.datas || [];

        if (!datas.length) return;

        // 🔥 AMBIL 1 ITEM SAJA
        const firstItem = datas[0];

        // 🔥 SIMPAN order_type UNTUK FILTER FE
        this.orderTypeFromFreight =
          firstItem.transport_order_template?.order_type || null;

        this.branchName = firstItem.branch_name || "";

        // ============================
        // mapping response ke rows
        // ============================
        this.rows = datas.map((item, i) => {
          const tonaseFormatted = item.tonnage
            ? `${item.tonnage
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")} Kg`
            : "";

          const pickup =
            item.pick_plan || item.pick_name
              ? `<div>${item.pick_plan || ""}</div><div>${
                  item.pick_name || ""
                }</div>`
              : "";

          const drop =
            item.dest_plan || item.dest_name
              ? `<div>${item.dest_plan || ""}</div><div>${
                  item.dest_name || ""
                }</div>`
              : "";

          const shipmentType =
            item.shipment_type === "MAIN"
              ? `<span class="shipment-main">MAIN</span>`
              : item.shipment_type || "";

          return {
            no: i + 1,
            transport_order_header_id: item.transport_order_header_id,
            jarak: item.distance ? `${item.distance} Km` : "",
            shipment_type: shipmentType,
            customer: item.company?.name || "",
            order: item.order_no || "",
            shipwithref: item.shipwith_ref || "",
            tonase: tonaseFormatted,
            pickup,
            drop,
          };
        });

        this.loadId = firstItem.load_id || this.loadId;
        this.totalRecords = this.rows.length;
      } catch (error) {
        console.error("Error loading freight builder data:", error);

        if (error.response?.status === 422) {
          this.$emit("closeModal");
          const msg =
            error.response.data?.errors?.message?.[0] || "Validation error";

          this.$swal.fire({
            icon: "warning",
            title: "Freight Builder - Information",
            text: msg,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: "OK",
          });
        }
      } finally {
        this.isLoadingShipmentFB = false;
      }
    },

    async destroyWhoEdit(idsToDelete = []) {
      this.isLoadingDeleteShipment = true;
      try {
        const ids =
          idsToDelete.length > 0
            ? idsToDelete
            : (this.rows || [])
                .map((r) => r.transport_order_header_id)
                .filter(Boolean);

        if (ids.length === 0) return;

        const payload = { transport_order_header_ids: ids.join(",") };
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/destroy-who-edit`;

        //console.log("🧹 Destroy Who Edit payload:", payload);

        await this.$http.post(url, payload, { timeout: 10000 });
        this.isLoadingDeleteShipment = false;

        //console.log("✔️ Destroy Who Edit success");
      } catch (error) {
        this.isLoadingDeleteShipment = false;
        console.error("❌ Destroy Who Edit error:", error);
        if (error.code === "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else if (error.response) {
          const status = error.response.status;
          if (status === 422) {
            const msg =
              error.response.data?.errors?.message?.[0] || "Validation error";
            await this.$swal.fire({
              icon: "warning",
              title: "Destroy Who Edit - Information",
              text: msg,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: "OK",
            });
          } else if (status === 500) {
            this.$router.push("/server-error");
          } else if (status === 401) {
            this.$router.push("/authorized-error");
          } else {
            this.$router.push("/page-not-found");
          }
        }
      }
    },
    async assignWhoEdit() {
      this.isLoadingAddShipment = true;
      try {
        const ids = (this.rows || [])
          .map((r) => r.transport_order_header_id)
          .filter(Boolean);

        if (ids.length === 0) {
          // nothing to do
          return;
        }

        const payload = { transport_order_header_ids: ids.join(",") };
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/assign-who-edit`;

        //console.log("🧹 Assign Who Edit payload:", payload);

        await this.$http.post(url, payload, { timeout: 10000 });
        this.isLoadingAddShipment = false;

        //console.log("✔️ Assign Who Edit success");
      } catch (error) {
        this.isLoadingAddShipment = false;
        console.error("❌ Assign Who Edit error:", error);
        if (error.code === "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else if (error.response) {
          const status = error.response.status;
          if (status === 422) {
            const msg =
              error.response.data?.errors?.message?.[0] || "Validation error";
            await this.$swal.fire({
              icon: "warning",
              title: "Assign Who Edit - Information",
              text: msg,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: "OK",
            });
          } else if (status === 500) {
            this.$router.push("/server-error");
          } else if (status === 401) {
            this.$router.push("/authorized-error");
          } else {
            this.$router.push("/page-not-found");
          }
        }
      }
    },
    refreshFreightBuilder() {
      // reset semua highlight
      this.rows.forEach((r) => (r._highlight = false));
      this.payableResult = "";
      this.marginResult = "";
      this.payableStatus = false;
      this.marginStatus = false;
      const ids = this.rows.map((r) => r.transport_order_header_id).join(",");

      const baseURI = `${this.$settings.endPoint}control-tower/transport-order-header/refresh-freight-builder`;

      //console.log("🔵 [Refresh Freight Builder] Params:", ids);

      // =========================================
      // 1️⃣ Aktifkan spinner jarak (tanpa HTML)
      // =========================================
      this.rows.forEach((r) => {
        r.jarak_loading = true; // spinner ON
        r.jarak = ""; // kosongkan tampilan
      });

      return (
        this.$http
          .get(baseURI, {
            params: { transport_order_header_ids: ids },
          })

          // ======================
          // 🟢 SUCCESS
          // ======================
          .then((response) => {
            this.isConnectionErrorShown = false;
            //console.log("🟢 [Refresh Freight Builder] Response:", response);

            const data = response.data.datas || [];

            data.forEach((item) => {
              const row = this.rows.find(
                (r) =>
                  Number(r.transport_order_header_id) ===
                  Number(item.transport_order_header_id),
              );

              if (row) {
                row.jarak = item.distance ? `${item.distance} Km` : "";
              }
            });

            // Matikan spinner
            this.rows.forEach((r) => (r.jarak_loading = false));

            //console.log("✅ Jarak berhasil diupdate:", this.rows);

            return { ok: true };
          })

          // ======================
          // 🔴 ERROR
          // ======================
          .catch((error) => {
            const result = this.handleApiError(
              error,
              "Refresh Freight Builder",
            );

            // Error → matikan spinner & kosongkan jarak
            this.rows.forEach((r) => {
              r.jarak_loading = false;
              r.jarak = "";
            });

            return result;
          })
      );
    },

    //!SECTION

    async submitLoadEntry() {
      this.isProcessing = true;
      this.isLoadingLoadId = true;
      this.canCalculate = false;
      this.canShowSubmitBtn = false;
      this.clearErrorMessages();

      try {
        // =======================
        // 🔍 FRONTEND VALIDATION
        // =======================
        const errors = {};
        const payload = this.buildPayloadLoadEntry();

        if (!payload.transport_order_header_id_max) {
          errors.calculate = [
            "Hasil calculate tidak dapat dilanjutkan ke proses selanjutnya",
          ];
        }

        if (this.selectedUnit === "Own" && !payload.vehicle_no) {
          errors.vehicle_no = ["Vehicle No wajib diisi untuk unit Own."];
        }

        if (this.selectedUnit === "Vendor") {
          if (!payload.carrier)
            errors.carrier_name = ["Transporter wajib diisi untuk Vendor."];
          if (!payload.type_truck)
            errors.type_truck = ["Type Truck wajib diisi untuk Vendor."];
        }

        if (!payload.vehicle_no)
          errors.vehicle_no = ["Vehicle No wajib diisi."];

        const isVendor = this.selectedUnit === "Vendor";

        if (!payload.driver_name) {
          errors.driver_name = ["Driver Name wajib diisi."];
        }

        if (!isVendor && !payload.driver_number) {
          errors.driver_number = ["Driver Number wajib diisi."];
        }
        
        if (!payload.customer_tujuan)
          errors.cust_tujuan = ["Customer tujuan wajib diisi."];

        if (Object.keys(errors).length > 0) {
          throw {
            response: {
              status: 422,
              data: {
                message: "Validation Error",
                errors,
              },
            },
            isFrontendValidation: true,
          };
        }

        // =======================
        // ⚠️ CONFIRM
        // =======================
        const highlightedRow = this.rows.find((r) => r._highlight === true);
        const proceed = await this.confirmIfNotMainShipment(highlightedRow);
        if (!proceed) return { ok: false, cancelled: true };

        // =======================
        // 🟦 DUMMY MODE
        // =======================
        const USE_DUMMY = false;
        const DUMMY_422 = true;

        if (USE_DUMMY) {
          const dummyResponse = await new Promise((resolve) => {
            setTimeout(() => {
              if (DUMMY_422) {
                resolve({
                  data: {
                    status: 422,
                    datas: { order_no: "2025120033" },
                    errors: { messages: ["PNL NEED APPROVAL"] },
                  },
                });
              } else {
                resolve({
                  data: {
                    status: 200,
                    datas: {
                      load_id: (
                        Math.floor(Math.random() * 90000000) + 10000000
                      ).toString(),
                    },
                  },
                });
              }
            }, 800);
          });

          if (
            dummyResponse.data.status === 422 &&
            this.isPnlNeedApproval(dummyResponse.data)
          ) {
            await this.handleNeedApproval(dummyResponse.data);
            return { ok: false, needApproval: true, dummy: true };
          }

          const loadId = dummyResponse.data.datas.load_id;
          this.loadId = loadId;
          this.isBlujaySent = true;
          this.isCalculated = false;
          this.isAfterSubmitSuccess = true;

          this.showGlobalMessage(
            "success",
            `Load berhasil dibuat dengan ID ${loadId} (Dummy)`,
            "Submit Freight Builder",
          );

          return { ok: true, dummy: true };
        }

        // =======================
        // 🟩 BE MODE
        // =======================
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/submit-freight-builder`;
        const res = await this.$http.post(url, payload);

        // ❗️CATATAN:
        // code di bawah ini TETAP DIBIARKAN
        // walaupun BE 422 tidak pernah masuk ke sini
        if (
          res.data?.status === 422 &&
          res.data?.errors?.messages &&
          this.isPnlNeedApproval(res.data)
        ) {
          await this.handleNeedApproval(res.data);
          return { ok: false, needApproval: true };
        }

        this.handleLogicalError(res);

        const loadId = res.data?.datas?.load_id;
        this.loadId = loadId;
        this.isBlujaySent = true;
        this.isCalculated = false;
        this.isAfterSubmitSuccess = true;

        this.showGlobalMessage(
          "success",
          `Load berhasil dibuat dengan ID ${loadId}`,
          "Submit Freight Builder",
        );

        return { ok: true };
      } catch (error) {
        // =======================
        // 🔥 PERBAIKAN UTAMA DI SINI
        // =======================
        const status = error?.response?.status;
        const data = error?.response?.data;

        if (status === 422 && this.isPnlNeedApproval(data)) {
          await this.handleNeedApproval(data);
          return { ok: false, needApproval: true };
        }

        // ⛔ error lain tetap ke handler umum
        this.handleApiError(error, "Submit Freight Builder");
        this.canCalculate = true;
        this.canShowSubmitBtn = true;
        return { ok: false };
      } finally {
        this.isProcessing = false;
        this.isLoadingLoadId = false;
      }
    },
    async handleNeedApproval(data) {
      console.log("[CHILD] handleNeedApproval called", data);

      const msg = data?.errors?.messages?.join(", ") || "PNL Need Approval";

      // tutup modal dari child
      console.log("[CHILD] calling closeModal()");
      await this.closeModal();
      console.log("[CHILD] closeModal() finished");

      // emit ke parent
      console.log("[CHILD] emit closeModal to parent");
      this.$emit("closeModal");

      // swal
      console.log("[CHILD] show swal");
      this.$swal.fire({
        icon: "warning",
        title: "Silahkan cek email PNL",
        text: msg,
        confirmButtonText: "OK",
      });
    },
    isPnlNeedApproval(data) {
      const messages = data?.errors?.messages || [];
      return messages.some(
        (m) => typeof m === "string" && m.toUpperCase() === "PNL NEED APPROVAL",
      );
    },
    async confirmIfNotMainShipment(row) {
      if (!row) return true;

      // 🔥 NORMALIZE shipment_type (hapus HTML)
      const shipmentType = row.shipment_type
        ? row.shipment_type.replace(/<[^>]*>/g, "").trim()
        : "";

      console.log("normalized shipment_type:", shipmentType);

      // ✅ kalau MAIN → tidak perlu swal
      if (shipmentType === "MAIN") return true;

      // ⚠️ NON MAIN → swal
      const result = await this.$swal({
        title: "Apakah Anda yakin ?",
        text: "Ujo untuk shipment Non Main lebih besar dari Shipment Main",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, lanjutkan",
        cancelButtonText: "Batal",
        reverseButtons: true,
      });

      return result.isConfirmed === true;
    },

    calculateFreightBuilder() {
      this.clearErrorMessages();
      this.isLoadingCalculate = true;
      this.isCalculated = false;
      this.isLoadingPayable = true;
      this.isLoadingMargin = true;

      // RESET ERROR
      this.errors = {};

      // =======================
      // 🔍 FRONTEND VALIDATION
      // =======================
      if (this.selectedUnit === "Own" && !this.vehicle_no) {
        this.errors.vehicle_no = ["Vehicle No wajib diisi untuk unit Own."];
      }

      if (this.selectedUnit === "Vendor") {
        if (!this.carrier_name)
          this.errors.carrier_name = ["Transporter wajib diisi untuk Vendor."];
        if (!this.type_truck)
          this.errors.type_truck = ["Type Truck wajib diisi untuk Vendor."];
      }

      if (Object.keys(this.errors).length > 0) {
        this.isProcessing = false;
        this.isLoadingCalculate = false;
        this.isLoadingPayable = false;
        this.isLoadingMargin = false;
        return { ok: false, msg: "validation-error" };
      }

      const USE_DUMMY = false; // true = dummy, false = backend
      if (USE_DUMMY) {
        return new Promise((resolve) => {
          setTimeout(() => {
            const dummyResponse = {
              datas: [
                {
                  transport_order_header_id: 3196,
                  max_ujo: 1500000,
                  pnl_margin: "",
                  status_ujo: "PNL NEED APPROVAL",
                  pnl_status: "AUTOMATIC APPROVED",
                },
              ],
            };
            resolve({ data: dummyResponse });
          }, 1500);
        })
          .then((res) => handleSuccess.call(this, res))
          .catch((err) => handleError.call(this, err));
      }

      // =======================
      // Mode Backend
      // =======================
      const carrier =
        this.selectedUnit === "Own"
          ? "0027-BAHANA PRESTASI"
          : this.carrier_name?.carrier_name;
      const vehicle_no =
        this.selectedUnit === "Own"
          ? this.vehicle_no?.vehicle_no
          : this.vehicle_no?.vehicle_no;
      const type_truck =
        this.selectedUnit === "Vendor" ? this.type_truck?.type_truck : null;

      const ids = this.rows
        .map((r) => r.transport_order_header_id)
        .filter((id) => id !== null && id !== undefined);

      const transportOrderIdsParam = ids.join(","); // BE biasanya mau string

      const url = `${this.$settings.endPoint}control-tower/transport-order-header/calculate-fb`;

      return this.$http
        .get(url, {
          params: {
            carrier,
            vehicle_no,
            type_truck,
            transport_order_header_ids: transportOrderIdsParam,
            transport_order_id_max: this.transport_order_header_id_max || null,
            type: this.selectedUnit ? this.selectedUnit.toLowerCase() : null,
          },
        })
        .then((res) => handleSuccess.call(this, res))
        .catch((err) => handleError.call(this, err));

      // =======================
      // Handler Success
      // =======================
      function handleSuccess(response) {
        this.clearErrorMessages();
        const datas = response.data?.datas || [];

        // ===============================
        // 🔥 SET GLOBAL ID MAX (SOURCE)
        // ===============================
        this.transport_order_header_id_max =
          datas[0]?.transport_order_header_id || null;

        this.isLoadingCalculate = false;
        this.isCalculated = true;
        this.isLoadingPayable = false;
        this.isLoadingMargin = false;

        // ===============================
        // 🔥 RESET ROW STATE
        // ===============================
        this.rows.forEach((r) => {
          r._highlight = false;
          r.transport_order_header_id_max = null;
          r.is_main_checked = false;
        });

        // ===============================
        // 🔥 APPLY BACKEND RESULT
        // ===============================
        datas.forEach((item) => {
          const match = this.rows.find(
            (r) =>
              Number(r.transport_order_header_id) ===
              Number(item.transport_order_header_id),
          );

          if (!match) return;

          match.transport_order_header_id_max = item.transport_order_header_id;

          // 🔥 SINKRON DARI GLOBAL (BUKAN DARI ROW)
          if (
            Number(item.transport_order_header_id) ===
            Number(this.transport_order_header_id_max)
          ) {
            match._highlight = true;
            match.is_main_checked = true;
          }
        });

        // ===============================
        // 🔥 PAYABLE & MARGIN
        // ===============================
        const first = datas[0] || {};

        this.payableResult =
          first.max_ujo != null
            ? `Rp ${Number(first.max_ujo).toLocaleString("id-ID")}`
            : "";

        this.marginResult =
          first.pnl_margin != null && first.pnl_margin !== ""
            ? `${first.pnl_margin}%`
            : "";

        this.payableStatus = first.status_ujo || "";
        this.marginStatus = first.pnl_status || "";

        this.canShowSubmitBtn = true;
        this.buildPayloadLoadEntry();
        return { ok: true };
      }

      // =======================
      // Handler Error
      // =======================
      function handleError(error) {
        this.transport_order_header_id_max = null;
        this.isLoadingCalculate = false;
        this.isCalculated = false;
        this.isLoadingPayable = false;
        this.isLoadingMargin = false;

        this.payableResult = "";
        this.marginResult = "";

        return this.handleApiError(error, "Calculate Freight Builder");
      }
    },

    //!SECTION
    resetPayloadLoadEntry() {
      // 🔥 reset global id max
      this.transport_order_header_id_max = null;

      // 🔥 reset carrier related
      this.carrier_name = null;

      // 🔥 reset vehicle
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.vehicle_branch_id = null;
      this.vehicle_branch_name = null;

      // 🔥 reset driver payload
      this.driver_nmk = null;
      this.driver_name = null;
      this.driver_number = null;

      // 🔥 reset truck & type
      this.type_truck = null;

      // 🔥 reset misc
      this.trailer_no = null;
      this.container = null;

      console.log("♻️ PAYLOAD DATA RESET (kecuali transport_order_header_ids)");
    },

    buildPayloadLoadEntry_v1() {
      const isVendor = this.selectedUnit === "Vendor";
      const isOwn = this.selectedUnit === "Own";

      const payload = {
        transport_order_header_id_max: this.transport_order_header_id_max,
        transport_order_header_ids: this.transport_order_header_ids,

        carrier: isOwn
          ? "0027-BAHANA PRESTASI"
          : this.carrier_name?.carrier_name || null,

        /* =======================
         * VEHICLE
         * ======================= */
        vehicle_no: isVendor
          ? this.vehicle_no?.vehicle_no || this.vehicle_no_vendor_text || null
          : this.vehicle_no?.vehicle_no || null,

        branch_id: this.vehicle_no?.branch_id ?? null,
        branch_name: this.vehicle_no?.branch_name ?? null,

        /* =======================
         * DRIVER
         * ======================= */
        driver_nmk: this.driver_id ? this.driver_id.driver_id : null,

        driver_name: this.driver_id
          ? this.driver_id.driver_name
          : this.driver_vendor_text || null,

        driver_number: this.driver_id ? this.driver_id.driver_number : null,

        /* =======================
         * OTHER
         * ======================= */
        type_truck: this.type_truck?.type_truck || null,
        type: this.selectedUnit ? this.selectedUnit.toLowerCase() : null,

        trailer_no: this.trailer_no || null,
        container: this.container_no || null,
        customer_tujuan: this.cust_tujuan || null,
        auto_process: this.autoProcess,
        toll_flag:this.routeTol||null,
      };

      console.log("📦 buildPayloadLoadEntry", JSON.stringify(payload, null, 2));

      return payload;
    },

    buildPayloadLoadEntry() {
      const isVendor = this.selectedUnit === "Vendor";
      const isOwn = this.selectedUnit === "Own";

      // ===============================
      // 🔥 AUTO SET ID MAX JIKA 1 ID
      // ===============================
      const idsArray = (this.transport_order_header_ids || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);

      let idMax = this.transport_order_header_id_max;

      if (idsArray.length === 1) {
        idMax = idsArray[0]; // single id
      }

      const payload = {
        transport_order_header_id_max: idMax,
        transport_order_header_ids: this.transport_order_header_ids,

        carrier: isOwn
          ? "0027-BAHANA PRESTASI"
          : this.carrier_name?.carrier_name || null,

        /* =======================
        * VEHICLE
        * ======================= */
        vehicle_no: isVendor
          ? this.vehicle_no?.vehicle_no || this.vehicle_no_vendor_text || null
          : this.vehicle_no?.vehicle_no || null,

        branch_id: this.vehicle_no?.branch_id ?? null,
        branch_name: this.vehicle_no?.branch_name ?? null,

        /* =======================
        * DRIVER
        * ======================= */
        driver_nmk: this.driver_id ? this.driver_id.driver_id : null,

        driver_name: this.driver_id
          ? this.driver_id.driver_name
          : this.driver_vendor_text || null,

        driver_number: this.driver_id ? this.driver_id.driver_number : null,

        /* =======================
        * OTHER
        * ======================= */
        type_truck: this.type_truck?.type_truck || null,
        type: this.selectedUnit ? this.selectedUnit.toLowerCase() : null,

        trailer_no: this.trailer_no || null,
        container: this.container_no || null,
        customer_tujuan: this.cust_tujuan || null,
        auto_process: this.autoProcess,
        toll_flag:this.routeTol||null,
      };

      console.log("📦 buildPayloadLoadEntry", JSON.stringify(payload, null, 2));

      return payload;
    },

    //!SECTION
    async addSelectedShipments() {
      this.clearErrorMessages();
      this.canShowSubmitBtn = false;
      this.canShowCalculate = false;
      if (this.selectedSlideIndexes.length === 0) return;

      // ambil data yang dipilih berdasarkan originalIndex
      const selected = this.filteredRows.filter((row) =>
        this.selectedSlideIndexes.includes(row.transport_order_header_id),
      );

      selected.forEach((sel) => {
        const indexExist = this.rows.findIndex(
          (r) => r.transport_order_header_id === sel.transport_order_header_id,
        );

        if (indexExist !== -1) {
          this.rows.splice(indexExist, 1, sel);
        } else {
          this.rows.push(sel);
        }
      });

      // reindex nomor
      // reindex + init FB state
      this.rows = this.rows.map((row, i) => ({
        ...row,
        no: i + 1,
        //_highlight: row._highlight ?? false,
        transport_order_header_id_max:
          row.transport_order_header_id_max ?? null,
        //is_main_checked: row.is_main_checked ?? false,
      }));

      // reset selection
      this.selectedSlideIndexes = [];
      this.selectAllSlide = false;
      await this.assignWhoEdit();
      this.closeSlidePanel();

      // 🔹 Jika sedang di mode "Shipment to Existing Load", ubah tampilan sesuai jumlah row
      if (this.rows.length <= 1) {
        this.showTable = false; // tampilkan card view
      } else {
        this.showTable = true; // tetap table view
      }

      // --- sync distance logic tetap sama ---
      let valid = false;

      if (this.selectedUnit === "Own") valid = !!this.vehicle_no?.vehicle_no;
      else if (this.selectedUnit === "Vendor")
        valid = !!this.type_truck?.type_truck;

      if (!valid) return;

      this.triggerSyncDistance();
    },
    async deleteSelectedRows() {
      this.clearErrorMessages();
      this.canShowSubmitBtn = false;
      this.canShowCalculate = false;
      if (this.selectedIndexes.length === 0) return;

      // 🔥 Ambil ID yang mau dihapus sebelum rows difilter
      const deletedIds = this.rows
        .filter((_, i) => this.selectedIndexes.includes(i))
        .map((r) => r.transport_order_header_id)
        .filter(Boolean);

      if (
        this.transport_order_header_id_max &&
        deletedIds.includes(this.transport_order_header_id_max)
      ) {
        console.warn("⚠️ ID MAX TERHAPUS, RESET GLOBAL ID MAX");
        this.transport_order_header_id_max = null;
      }

      // Hapus row dari tabel
      this.rows = this.rows.filter((_, i) => !this.selectedIndexes.includes(i));

      // 🔥 Jika GLOBAL ID MAX sudah tidak ada di rows → reset
      if (
        this.transport_order_header_id_max &&
        !this.rows.some(
          (r) =>
            Number(r.transport_order_header_id) ===
            Number(this.transport_order_header_id_max),
        )
      ) {
        this.transport_order_header_id_max = null;
      }

      this.selectedIndexes = [];
      this.selectAll = false;

      // Reindex
      this.rows = this.rows.map((row, i) => ({
        ...row,
        no: i + 1,
        //_highlight: row._highlight ?? false,
        transport_order_header_id_max:
          row.transport_order_header_id_max ?? null,
        //is_main_checked: row.is_main_checked ?? false,
      }));

      // 🔥 Kirim hanya ID yang dihapus
      await this.destroyWhoEdit(deletedIds);

      this.triggerSyncDistance();

      // existing load mode handler
      if (this.selectedUnit === "Shipment to Existing Load") {
        this.showTable = this.rows.length > 1;
      }
    },

    // ---------------------------
    // MODAL MAIN TABLE SELECTION
    // ---------------------------
    toggleRowSelection(index) {
      const pos = this.selectedIndexes.indexOf(index);
      if (pos === -1) this.selectedIndexes.push(index);
      else this.selectedIndexes.splice(pos, 1);

      this.selectAll =
        this.selectedIndexes.length === this.rowListShipments.length;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedIndexes = this.rows.map((_, i) => i);
      } else {
        this.selectedIndexes = [];
      }
    },
    isSelected(index) {
      return this.selectedIndexes.includes(index);
    },

    // ---------------------------
    // SLIDE PANEL SELECTION
    // ---------------------------
    toggleRowSelectionSlide(row) {
      const id = row.transport_order_header_id;

      if (this.selectedSlideIndexes.includes(id)) {
        this.selectedSlideIndexes = this.selectedSlideIndexes.filter(
          (x) => x !== id,
        );
      } else {
        this.selectedSlideIndexes.push(id);
      }

      this.selectAllSlide =
        this.selectedSlideIndexes.length === this.filteredRows.length;
    },
    toggleSelectAllSlide() {
      if (this.selectAllSlide) {
        // checkbox is checked → select all
        this.selectedSlideIndexes = this.filteredRows.map(
          (r) => r.transport_order_header_id,
        );
      } else {
        // checkbox unchecked → clear all
        this.selectedSlideIndexes = [];
      }
    },
    isSelectedSlide(row) {
      return this.selectedSlideIndexes.includes(row.transport_order_header_id);
    },

    // ---------------------------
    // SLIDE PANEL OPEN / CLOSE
    // ---------------------------
    async openSlidePanel() {
      this.showSlidePanel = true;
      this.selectedSlideIndexes = [];
      this.selectAllSlide = false;

      this.isLoadingShipmentListAvailable = true;
      await this.loadShipmentListAvailable(); // tunggu data selesai load
      this.isLoadingShipmentListAvailable = false;

      window.addEventListener("keydown", this.handleEsc);
    },
    closeSlidePanel() {
      this.showSlidePanel = false;
      window.removeEventListener("keydown", this.handleEsc);
    },
    handleEsc(e) {
      if (e.key === "Escape") this.closeSlidePanel();
    },
    handleEscClose(e) {
      // ketika ESC ditekan dan modal terbuka, jangan emit langsung - panggil closeModal()
      if (e.key === "Escape" && this.showModal) {
        this.closeModal();
      }
    },
    async closeModal() {
      // jika sudah dalam proses closing, jangan lakukan lagi
      if (this.closingByChild) return;

      try {
        this.closingByChild = true;

        // panggil API destroy-who-edit (jika ada ids)
        await this.destroyWhoEdit();
      } catch (err) {
        console.error("closeModal: destroyWhoEdit failed", err);
        // tetap lanjut menutup modal agar user tidak terjebak
      } finally {
        // beri tahu parent untuk tutup modal
        this.$emit("closeModal");
        // reset flag (watcher yang melihat perubahan showModal->false akan memeriksa flag)
        // kita reset sedikit setelah emit (biar watcher masih bisa melihat flag true)
        setTimeout(() => {
          this.closingByChild = false;
        }, 50);
      }
    },

    //!SECTION
    debounce(func, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
      };
    },
    showGlobalMessage(type, message, title = "Information") {
      const id = Date.now();

      const safeMessage =
        typeof message === "string"
          ? message
          : message?.message ||
            message?.response?.ClientException ||
            JSON.stringify(message);

      this.globalMessages.push({
        id,
        type,
        title,
        message: safeMessage,
      });

      if (type === "success") {
        setTimeout(() => {
          this.removeMessage(id);
        }, 5000);
      }
    },
    removeMessage(id) {
      this.globalMessages = this.globalMessages.filter((msg) => msg.id !== id);
    },
    closeGlobalMessage() {
      this.globalResponse.show = false;
    },
    clearErrorMessages() {
      // 🔹 HANYA clear error UI
      this.globalMessages = this.globalMessages.filter(
        (msg) => msg.type !== "error",
      );

      this.errors = {};
    },

    handleResize() {
      this.syncScrollWidths();
    },
    syncScroll(e) {
      const top = this.$refs.topScroll;
      const bottom = this.$refs.bottomScroll;
      if (!top || !bottom) return;

      if (e.target === top) bottom.scrollLeft = top.scrollLeft;
      else if (e.target === bottom) top.scrollLeft = bottom.scrollLeft;
    },
    syncScrollSlide(e) {
      const top = this.$refs.topScrollSlide;
      const bottom = this.$refs.bottomScrollSlide;
      if (!top || !bottom) return;
      window.requestAnimationFrame(() => {
        if (e.target === top) {
          bottom.scrollLeft = top.scrollLeft;
        } else if (e.target === bottom) {
          top.scrollLeft = bottom.scrollLeft;
        }
      });
    },
    syncScrollWidths() {
      this.$nextTick(() => {
        const top = this.$refs.topScroll;
        const bottom = this.$refs.bottomScroll;
        if (!top || !bottom) return;

        const content = top.querySelector(".scroll-content");
        const table = bottom.querySelector("table");
        if (content && table)
          content.style.width = table.scrollWidth + 2 + "px";
      });
    },

    //!SECTION
    handleApiError(error, featureName = "Process") {
      console.error(`🔴 [${featureName}] Error:`, error);

      // ========================================
      // 🔥 GLOBAL NETWORK / TIMEOUT HANDLER
      // ========================================
      const isNetworkError =
        error.code === "ERR_NETWORK" ||
        error.message?.toLowerCase().includes("network error") ||
        (!error.response && error.request);

      const isTimeout =
        error.code === "ECONNABORTED" ||
        error.message?.toLowerCase().includes("timeout");

      if (isNetworkError || isTimeout) {
        // Cegah tampil berulang
        if (!this.isConnectionErrorShown) {
          this.isConnectionErrorShown = true;

          this.showGlobalMessage(
            "error",
            this.$t("check_internet_connection_txt"),
            featureName,
          );
        }

        return {
          ok: false,
          msg: isTimeout ? "timeout" : "network-error",
        };
      }

      // ========================================
      // 🟡 Error Dengan Response dari Backend
      // ========================================
      if (error.response) {
        const status = error.response.status;

        // 422 — VALIDATION
        if (status === 422) {
          const err = error.response.data?.errors || {};
          let msg = "Validation error";

          if (Array.isArray(err.message) && err.message.length > 0) {
            const first = err.message[0];
            msg = typeof first === "string" ? first : first?.message || msg;
          } else {
            const firstField = Object.keys(err)[0];
            if (firstField && Array.isArray(err[firstField])) {
              msg = err[firstField][0];
            }
          }

          this.showGlobalMessage("error", msg, featureName);
          return { ok: false, msg };
        }

        // 500
        if (status === 500) {
          this.$router.push("/server-error");
          return { ok: false, msg: "server-error" };
        }

        // 401
        if (status === 401) {
          this.$router.push("/authorized-error");
          return { ok: false, msg: "unauthorized" };
        }

        // lainnya
        this.$router.push("/page-not-found");
        return { ok: false, msg: "not-found" };
      }

      // ========================================
      // 🟣 Fallback Error
      // ========================================
      return { ok: false, msg: "unknown-error" };
    },
    handleLogicalError(res) {
      if (res?.data && res.data.status && res.data.status !== 200) {
        throw {
          response: {
            status: res.data.status,
            data: res.data,
          },
        };
      }
    },
    resultError(msg) {
      let html = "";

      // ✅ STRING
      if (typeof msg === "string") {
        html = msg.replace(/\n/g, "<br>");
      }

      // ✅ ARRAY: ["err1", "err2"]
      else if (Array.isArray(msg)) {
        html = msg.map((m) => `• ${m}`).join("<br>");
      }

      // ✅ OBJECT: { field: ["err"] }
      else if (typeof msg === "object" && msg !== null) {
        html = Object.values(msg)
          .flat()
          .map((m) => `• ${m}`)
          .join("<br>");
      }

      // ✅ FALLBACK
      else {
        html = "Terjadi kesalahan validasi";
      }

      this.$swal({
        icon: "error",
        title: "Validation Error",
        html,
      });
    },
  },
  created() {
    this.debouncedSyncDistance = this.debounce(() => {
      this.syncDistance();
    }, 600);
  },
  mounted() {
    this.$nextTick(() => {
      // 🔹 Pastikan lebar scrollbar sinkron
      this.syncScrollWidths();
      setTimeout(() => this.syncScrollWidths(), 100);

      // 🔹 Event listener
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("keydown", this.handleEscClose);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    // 🧹 Hapus listener ESC saat komponen di-unmount
    window.removeEventListener("keydown", this.handleEscClose);
    window.removeEventListener("keydown", this.handleEsc);
  },
};
</script>

<style scoped>
.refresh-btn {
  opacity: 0.8;
  transition: 0.2s ease;
}

.refresh-btn:hover {
  opacity: 1;
  transform: rotate(25deg) scale(1.15); /* sedikit interaktif */
}

.highlight-row {
  background-color: #ffb8c1 !important;
}

/* default MAIN */
::v-deep .shipment-main {
  color: red;
  font-weight: 700;
}

/* row dicheck → teks putih */
.highlight-row td {
  color: #060404 !important;
}

/* shipment type MAIN dicheck → kuning */
::v-deep .highlight-row .shipment-main {
  color: #1203eb !important;
  font-weight: 700;
}

/* =============================
   TABLE SCROLL AREA
============================= */
.table-scroll-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
  max-height: 400px; /* batas tinggi area tabel */
  overflow: hidden;
}

.table-scroll {
  display: block;
  max-height: 240px; /* kira-kira cukup untuk 5 baris */
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  background: #fff;
  border-top: 1px solid #dee2e6;
}

.table-scroll thead th {
  position: sticky;
  top: 0; /* pastikan header tetap di atas area scroll */
  background: #fff;
  z-index: 5;
  border-bottom: 2px solid #dee2e6;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  text-transform: capitalize !important;
}

/* area scroll atas (dummy scrollbar horizontal kecil) */
.top-scrollbar {
  height: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  background: #f9f9f9;
  border-bottom: 1px solid #dee2e6;
}
.top-scrollbar::-webkit-scrollbar {
  height: 8px;
}
.top-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

/* area utama scroll tabel */
.bottom-scrollbar {
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  position: relative;
  background: #fff;
}
.bottom-scrollbar table {
  min-width: max-content;
}

/* sticky header table */
.bottom-scrollbar table thead th {
  position: sticky;
  top: -2px; /* sedikit dinaikkan agar sela tertutup sempurna */
  background: #fff;
  z-index: 5;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  text-transform: capitalize !important;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}

/* hover row dan isi table */
.table-hover tbody tr:hover {
  background-color: #f5faff;
}
.bottom-scrollbar td {
  white-space: normal;
  word-break: break-word;
  vertical-align: middle;
}

/* baris terpilih */
.selected-row {
  background-color: #b8daff !important;
}

/* =============================
   SPINNER
============================= */
.spinner-border {
  width: 1rem !important;
  height: 1rem !important;
}

/* =============================
   INPUT READONLY
============================= */
.readonly-input[readonly] {
  background-color: #e9ecef;
  opacity: 1;
  cursor: text;
}
.readonly-clear[readonly] {
  background-color: #fff !important;
  opacity: 1 !important;
  cursor: default;
  font-weight: 700 !important;
  color: #000 !important;
}

/* =============================
   SLIDE PANEL ANIMATION
============================= */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0%);
  opacity: 1;
}

/* =============================
   SLIDE PANEL CONTAINER
============================= */
.slide-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 70%;
  background-color: #fff;
  z-index: 1050;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: none;
}
.slide-panel.open {
  display: block;
}

/* =============================
   STICKY FOOTER BUTTON AREA
============================= */
.slide-body {
  display: flex;
  flex-direction: column;
  max-height: calc(70vh - 80px);
}
.slide-body .table-scroll-wrapper {
  flex: 1;
}
.slide-body .mt-2.text-end {
  flex-shrink: 0;
  padding-top: 0.75rem;
  border-top: 1px solid #dee2e6;
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

/* =============================
   MODAL STYLING
============================= */
.modal {
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.modal-xxl {
  max-width: 80%;
}
.modal-dialog {
  height: 95%;
  display: flex;
  flex-direction: column;
}
.modal-content {
  border-radius: 10px;
  border: none !important;
  box-shadow: none !important;
  overflow: hidden;
}

/* =============================
   MISC
============================= */
.section-block h6 {
  font-weight: 600;
  color: #333;
}
.scroll-content {
  height: 1px;
}
</style>
